import { allReportsTr } from './all-reports.js';
import { attachmentPreviewTr } from './attachment-preview.js';
import { cashTr } from './cash.js';
import { charterPartiesTr, cpAnalysisTr, voyageReferenceTr } from './charter-party.js';
import { classIntegrationTr } from './class-integration.js';
import { crewListTr } from './crew-list.js';
import { crewNotesTr } from './crew-notes.js';
import { crewProfileTr } from './crew-profile.js';
import { dailyTr } from './daily.js';
import { defectsTr } from './defects.js';
import { documentsTr } from './documents.js';
import { drillFindingTr } from './drill-finding.js';
import { drillPlanTr } from './drill-plan.js';
import { drillRecordTr } from './drill-record.js';
import { drillReportTr } from './drill-report.js';
import { drillsTr } from './drills.js';
import { drydockTr } from './drydock.js';
import { drydockAuditTr, drydockFleetTr, drydockReportTr } from './drydock-report.js';
import type { UiResources } from './en.js';
import { formsTr } from './forms.js';
import { fuelTr } from './fuel.js';
import { fuelAnalysisTr, voyageCardsTr } from './fuel-analysis.js';
import { helpTr, pageHelpTr } from './help.js';
import { hseTr } from './hse.js';
import { companyNcTr, hseExtraTr, portCallPdfTr, recordPdfTr } from './hse-m15g.js';
import { loginAccountsTr } from './login-accounts.js';
import { masterSectionTr } from './master-section.js';
import { materialsTr, stockTr } from './materials.js';
import { officePackTr } from './office-pack.js';
import { payrollTr } from './payroll.js';
import { pmsTr } from './pms.js';
import { pmsAuditTr } from './pms-audit.js';
import { pmsLibraryTr } from './pms-library.js';
import { pmsReportsTr } from './pms-reports.js';
import { portCallsTr } from './port-calls.js';
import { portsTr } from './ports.js';
import { provisionsTr } from './provisions.js';
import { purchasingTr } from './purchasing.js';
import { purchasingMarketTr } from './purchasing-market.js';
import { purchasingShipTr } from './purchasing-ship.js';
import { reportsTr } from './reports.js';
import { returnedTr } from './returned.js';
import { riskTr } from './risk.js';
import { riskDashboardTr } from './risk-dashboard.js';
import { riskFindingsTr } from './risk-findings.js';
import { riskLibraryTr } from './risk-library.js';
import { riskMasterTr } from './risk-master.js';
import { riskRegisterTr } from './risk-register.js';
import { riskVerificationTr } from './risk-verification.js';
import { settingsTr } from './settings.js';
import { setupTr } from './setup.js';
import { restHoursClockTr, shipClockTr } from './ship-clock.js';
import { signOnOffTr } from './sign-on-off.js';
import { supplierAccountTr } from './supplier-account.js';
import { supplierNoticesTr } from './supplier-notices.js';
import { supplierProfileTr } from './supplier-profile.js';
import { tasksTr } from './tasks.js';
import { testAccountsTr } from './test-accounts.js';
import { vesselCertificatesTr } from './vessel-certificates.js';
import { victuallingTr } from './victualling.js';
import { voyageContextTr } from './voyage-context.js';
import { voyageLinksTr } from './voyage-links.js';
import { voyageRecordTr } from './voyage-record.js';

/** Ortak kabuk, menü ve ortak ekran metinleri: Türkçe. */
export const tr: UiResources = {
  menu: {
    dashboard: 'Pano',
    fleet: 'Filo',
    fleetVessels: 'Gemiler',
    voyage: 'Sefer',
    // Sefer alt grupları (ADR 0082; ortağın sefer-1, sefer-6)
    voyageReports: 'Raporlar',
    voyageReportsAll: 'Tüm Raporlar',
    voyageReportsArrival: 'Varış Raporu',
    voyageReportsDailyPort: 'Günlük Liman Raporu',
    voyageReportsDeparture: 'Kalkış Raporu',
    voyageReportsAnchoring: 'Demirleme Raporu',
    voyageReportsAnchorAweigh: 'Demir Alma Raporu',
    voyageReportsDrifting: 'Sürüklenme Raporu',
    voyageReportsDriftDeparture: 'Sürüklenme Bitiş Raporu',
    voyageReportsCanalStrait: 'Kanal / Boğaz Geçişi',
    voyageReportsNoon: 'Öğle Raporu',
    voyageRecords: 'Sefer Raporları',
    voyageList: 'Sefer Listesi',
    voyageNew: 'Yeni Sefer',
    voyageDetails: 'Sefer Ayrıntıları',
    voyageTimeline: 'Sefer Zaman Çizelgesi',
    voyageSummary: 'Sefer Özeti',
    voyageLegs: 'Bacak / Olay',
    voyageRoute: 'Rota ve Mesafeler',
    voyageAnalysis: 'Performans ve Analiz',
    voyageFuelAnalysis: 'Yakıt ve Tüketim Analizi',
    voyageReference: 'Referans Veriler',
    voyageDistances: 'Liman Mesafe Kütüphanesi',
    voyageReportTemplates: 'Rapor Şablonları',
    voyageEventTypes: 'Olay Türleri',
    voyageNoonReport: 'Öğle Raporu',
    voyagePerformance: 'Sefer Performansı',
    voyageCharterParties: 'Çarter Sözleşmeleri',
    voyageCharterParty: 'Çarter Performansı',
    voyageCiiMrv: 'CII / MRV',
    crew: 'Personel',
    crewList: 'Personel Listesi',
    crewLists: 'Mürettebat Listeleri (FAL 5)',
    crewCertificates: 'Sertifikalar ve Belgeler',
    crewTraining: 'Eğitim ve Kurslar',
    crewSignOnOff: 'Katılış / Ayrılış',
    crewLoginAccounts: 'Giriş Hesapları',
    crewCalendar: 'Personel Takvimi',
    crewRestHours: 'Çalışma ve Dinlenme Saatleri',
    crewShipClock: 'Gemi Saati Kaydı',
    crewPayroll: 'Payroll',
    crewPayrollMonthly: 'Aylık Hesap',
    crewPayrollAdvances: 'Avans ve Kesintiler',
    crewPayrollAllotments: 'Allotment',
    crewPayrollPayslips: 'Ücret Pusulası',
    crewPayrollPayments: 'Ödeme Defteri',
    crewPayrollClosing: 'Ay Kapanışı',
    crewPayrollReports: 'Payroll Raporları',
    operations: 'Operasyon',
    operationsDailyPlan: 'Günlük İş Planı',
    operationsDailyReports: 'Günlük Raporlar',
    operationsPortCalls: 'Liman Ziyaretleri',
    operationsDrills: 'Tatbikatlar',
    operationsDrillsDashboard: 'Pano',
    operationsDrillsPlanner: 'Planlayıcı',
    operationsDrillsRecords: 'Kayıtlar',
    operationsDrillsCompetency: 'Mürettebat Yetkinliği',
    operationsDrillsAnalytics: 'Analitik',
    operationsDrillsLibrary: 'Kütüphane',
    compliance: 'Uygunluk',
    complianceIsmForms: 'ISM Formları',
    complianceIsmFormList: 'Form Listesi',
    complianceIsmFormCategories: 'Form Kategorileri',
    complianceIsmFormHistory: 'Form Geçmişi',
    complianceManuals: 'El Kitapları',
    complianceVesselCertificates: 'Gemi Sertifikaları',
    // HSEQ Reports alt grubu (ADR 0097 Ek): All Reports ve türler
    complianceHseqReports: 'HSEQ Raporları',
    complianceHseq: 'Tüm Raporlar',
    complianceDeficiency: 'Eksiklik',
    complianceNonConformity: 'Uygunsuzluk',
    complianceAccident: 'Kaza',
    complianceNearMiss: 'Ramak Kala',
    complianceRisk: 'Risk Değerlendirmesi',
    complianceRiskDashboard: 'Pano',
    complianceRiskAssessment: 'Risk Değerlendirmeleri',
    complianceRiskLibrary: 'Kütüphane',
    complianceRiskRegister: 'Gemi Risk Kaydı',
    complianceRiskVerification: 'Operasyonel Doğrulama',
    complianceRiskFindings: 'Bulgular ve Faaliyetler',
    complianceRiskReports: 'İzleme ve Raporlar',
    complianceRiskMasterData: 'Ana Veriler',
    materialMaster: 'Malzeme Kataloğu',
    purchasing: 'Satın Alma',
    purchasingRequisitions: 'Malzeme Talebi',
    purchasingRfq: 'Teklif İsteği',
    purchasingOrders: 'Satın Alma Siparişleri',
    purchasingSuppliers: 'Tedarikçiler',
    purchasingGrn: 'Mal Kabul',
    purchasingStock: 'Stok Yönetimi',
    inventory: 'Envanter',
    inventorySpareParts: 'Yedek Parça',
    inventoryStock: 'Stok Giriş / Çıkış',
    inventoryProvision: 'Kumanya',
    inventoryVictualling: 'İaşe Raporu',
    pms: 'Bakım (PMS)',
    pmsEquipment: 'Ekipman Listesi',
    pmsPlan: 'Bakım Planı',
    pmsPostponements: 'Ertelemeler',
    pmsWorkOrders: 'İş Emirleri',
    pmsDefects: 'Arızalar',
    pmsLibrary: 'PMS Kütüphanesi',
    pmsClassIntegration: 'Klas Entegrasyonu',
    pmsHistory: 'Geçmiş',
    pmsDrydock: 'Havuzlama',
    pmsDrydockProjects: 'Projeler',
    pmsDrydockInspection: 'Havuz Öncesi Denetim',
    pmsDrydockFleet: 'Filo görünümü',
    pmsDrydockJobs: 'Tersane İş Listesi',
    pmsDrydockLibrary: 'Denetim Kütüphanesi',
    fuelManagement: 'Yakıt Yönetimi',
    finance: 'Finans',
    financeCtm: 'Kaptana Nakit (CTM)',
    financeCashAccounts: 'Kasalar',
    financeCtmRequests: 'CTM Talepleri',
    financeCtmApprovals: 'CTM Onay ve Transfer',
    financeCtmReceipts: 'CTM Teslim Teyidi',
    financeCtmHistory: 'CTM Geçmişi',
    financeCash: 'Kasa Hesabı',
    financeCashTransactions: 'Kasa İşlemleri',
    financeCashBalances: 'Para Birimine Göre Bakiye',
    financeCashReconciliation: 'Kasa Mutabakatı',
    financeCashMonthly: 'Aylık Kasa Raporu',
    financeReports: 'Finans Raporları',
    reports: 'Raporlar',
    settings: 'Ayarlar',
  },
  shell: {
    mainMenu: 'Ana menü',
    toggleMenu: 'Menüyü aç/kapat',
    closeMenu: 'Menüyü kapat',
    expand: '{{name}} grubunu aç',
    search: 'Gemi, sefer, liman ara…',
    searchLabel: 'Ara',
    searchEmpty: 'Sonuç yok',
    searchModules: 'Modüller',
    notifications: 'Bildirimler',
    notificationsCount_one: 'Bildirimler, {{count}} yeni',
    notificationsCount_other: 'Bildirimler, {{count}} yeni',
    notificationsEmpty: 'Yeni bildirim yok.',
    userMenu: 'Kullanıcı menüsü',
    language: 'Dil',
    signOut: 'Çıkış yap',
    breadcrumb: 'Sayfa yolu',
    defaultTagline: 'Gemi ve Ofis Yönetimi',
    sloganTitle: 'Güvenli Personel',
    sloganSubtitle: 'Güvenli Sefer',
    vesselLabel: 'Gemi',
    imo: 'IMO {{imo}}',
    selectVessel: 'Gemi seç',
    home: 'Ana sayfa',
    skipToContent: 'İçeriğe geç',
    officeUser: 'Ofis',
  },
  /** Onayda parola (ADR 0056, ADR 0075): parolasız onayın bilgi metni ve Ayarlar ▸ Onaylar. */
  approvalPolicy: {
    note: 'Bu kaydı onaylıyorsunuz; onayınız içeriğin özetini (hash) taşır.',
    settings: {
      title: 'Onaylar',
      text: 'Onayda parolanın yeniden istenmesi. Varsayılan olarak hiçbir onay parolayı yeniden istemez: kullanıcı kendi parolasıyla girmiştir ve her onayı açık bir onay adımıyla verir. Her onayda ve teyitte parola istemek için ayarı açın.',
      reauthAlways: 'Onayda parolayı her yerde iste',
      reauthAlwaysHint:
        'Açıkken her onay ve teyit parolayı yeniden ister. Ayar gemilere sonraki senkronla iner.',
      saved: 'Kaydedildi.',
      save: 'Kaydet',
      error: 'Ayar kaydedilemedi.',
      retry: 'Yeniden dene',
    },
  },
  common: {
    retry: 'Tekrar dene',
    accessDenied: {
      title: 'Bu sayfayı görme yetkiniz yok.',
      description: 'Erişim için şirket yöneticinize başvurun.',
    },
    clearFilters: 'Filtreleri temizle',
    noData: 'Veri yok',
    loadError: 'Veri okunamadı.',
    view: 'Görüntüle',
    clearDate: 'Tarihi temizle',
    datePlaceholder: 'GG.AA.YYYY',
    dateTimePlaceholder: 'GG.AA.YYYY SS:DD',
    // LT + UTC zaman girişi (ADR 0057 §2)
    time: {
      lt: 'LT',
      utc: 'UTC',
      ltZone: 'LT ({{zone}})',
      entryMode: '{{field}}: LT ya da UTC ile gir',
      offsetGroup: 'UTC farkı',
      zoneGroup: 'Saat dilimi (rapor anındaki fark)',
    },
    hours: 'Saat',
    minutes: 'Dakika',
    previousMonth: 'Önceki ay',
    nextMonth: 'Sonraki ay',
    apply: 'Uygula',
    position: {
      degrees: '{{label}} derece',
      minutes: '{{label}} dakika',
      hemisphere: '{{label}} yön',
    },
    unsaved: {
      title: 'Kaydedilmemiş değişiklikler silinsin mi?',
      message: 'Bu sayfadaki değişiklikler kaydedilmedi. Sayfadan çıkarsanız kaybolur.',
      stay: 'Sayfada kal',
      discard: 'Sil ve çık',
    },
  },
  comingSoon: {
    badge: 'Hazırlanıyor',
    title: 'Bu modül hazırlanıyor',
    planned: 'Planlanan: {{stage}}',
    back: 'Panoya dön',
    reference: 'Ekran onaylı tasarıma göre yapılır; gemi uygulamasına ve ofise birlikte gelir.',
    officeBadge: 'Ofis',
    officeTitle: 'Bu ekran ofiste kullanılır',
    officeNote:
      'Tedarikçi, teklif isteği ve teklifler ofisin ticari verisidir; gemiye inmez. Talepler ve onayları Malzeme Talebi altında izlenir.',
    modules: {
      voyageList: 'Geminin bütün seferleri; bacakları, olayları ve durumlarıyla.',
      voyageNew: 'Planlanan çarter hızı, tüketimi ve hava sınırlarıyla yeni sefer.',
      voyageLegs: 'Her bacağın kalkış, öğle, COSP, EOSP ve varış olayları.',
      voyageRoute: 'Seferin limanları, bacak mesafeleri ve liman sırası önerisi.',
      voyageDistances: 'Şirketin limandan limana mesafe tablosu ve şirket limanları.',
      voyageNoonReport:
        'Günlük öğle raporu: konum, mesafe ve hız, makine, yakıt ve ROB, hava ve deniz.',
      voyagePerformance: 'Hız, tüketim ve sürenin sefer planıyla karşılaştırması.',
      voyageCharterParties:
        'Geminin çarter sözleşmeleri: şartlar, teslim ve iade, çarter dışı seyirler.',
      voyageCharterParty: 'Hava sınırlarıyla çarter hızı ve tüketim performansı.',
      voyageCiiMrv: 'EU MRV, IMO DCS ve CII raporları.',
      voyageDetails:
        'Sefer kaydı: bağlı raporlar, olaylar, bacak mesafeleri, yakıt tüketimi ve sefer dönemleri.',
      voyageTimeline:
        'Seferin yatay zaman çizelgesi: olaylar, bacaklar ve mesafeler, liman ve demir süreleri.',
      voyageSummary:
        'Raporlardan türetilen seyir, liman, demir ve sürüklenme süresi, mesafe ve tüketim.',
      voyageFuelAnalysis:
        'Denizde, limanda, demirde ve sürüklenmede yakıt türüne göre tüketim; günlük ortalama ve ikmal.',
      voyageReportTemplates: 'Sefer rapor türlerinin bölümleri ve zorunlu alanlarıyla kataloğu.',
      voyageEventTypes:
        'Raporlarda kaydedilen olaylar (EOSP, COSP, Pilot On / Off, NOR, First Line, All Fast …), kaynak rapor ve alanıyla.',
      crewList: 'Gemideki ve karadaki personel; rütbe, gemi ve tarihleriyle.',
      crewLists:
        'Varış ve kalkış için IMO FAL Form 5 mürettebat listeleri; gemideki personelden hazırlanır.',
      crewCertificates: 'Personel sertifikaları ve belgeleri; geçerlilik takibiyle.',
      crewTraining: 'Tatbikat bulgularından gelen eğitim ihtiyaçları ve nasıl karşılandıkları.',
      pmsDrydockFleet:
        'Filonun havuzlama projeleri: denetimler, ofiste bekleyen işler, tersane ilerlemesi ve doğrulama (yalnız ofis).',
      operationsDrillsAnalytics:
        'Filo tatbikat analitiği: tamamlanma oranı, gecikmeler, toplanma ve tepki süresi eğilimi.',
      crewSignOnOff: 'Katılış ve ayrılış kayıtları.',
      crewLoginAccounts:
        'Personelin ve ofisin giriş e-postaları ve parolaları; ofiste yönetilir (yalnız ofis).',
      crewCalendar: 'Personel rotasyonu ve izin takvimi.',
      crewRestHours: 'MLC 2006 ve STCW denetimiyle çalışma ve dinlenme saatleri.',
      operationsDailyPlan: 'Departmanlara göre günlük iş planı.',
      operationsDailyReports: 'Departmanların günlük raporları.',
      operationsPortCalls: 'Liman ziyaretleri, acenteler ve liman faaliyetleri.',
      complianceIsmFormList:
        'Şirket kütüphanesindeki ISM formları: önizleme, bilgiler ve revizyonlar.',
      complianceIsmFormCategories: 'Form ağacının klasörleri olarak form kategorileri.',
      complianceIsmFormHistory: 'Onayları ve geçmişiyle doldurulmuş formlar.',
      complianceManuals: 'Kontrollü revizyonlu şirket el kitapları; gemide teyit.',
      complianceVesselCertificates: 'Sörvey ve vadeleriyle statü, klas ve bayrak sertifikaları.',
      complianceHseq: 'Uygunsuzluk, eksiklik, ramak kala ve kaza tek yerde, dört aşamada.',
      complianceDeficiency: 'Düzeltici faaliyet ve kapanışıyla eksiklikler.',
      complianceNonConformity: 'Denetim ve PSC sonrası uygunsuzluklar.',
      complianceAccident: 'Kaza raporları ve incelemeler.',
      complianceNearMiss: 'Ramak kala raporları ve çıkarılan dersler.',
      complianceRisk: 'Risk değerlendirmeleri ve şirket risk kütüphanesi.',
      complianceRiskAssessment: '5×5 matris ve kontrol önlemleriyle risk değerlendirmeleri.',
      complianceRiskLibrary:
        'Şirketin risk değerlendirmeleri: Builder, inceleme, onay, yayımlı sürümler ve gemi ataması.',
      complianceRiskRegister:
        'Gemiye atanmış şirket risk değerlendirmeleri, gözden geçirme günleri ve gemideki okundu onayları.',
      complianceRiskVerification:
        'Planlanan operasyonu güncel risk değerlendirmesine göre doğrulayın ve iş başlamadan yetki verin.',
      complianceRiskFindings:
        'Operasyonel doğrulamaların bulguları: düzeltici faaliyetler, yeniden doğrulama, şirkete yükseltme ve kapanış.',
      complianceRiskMasterData:
        'Şirket risk kütüphanesi: faaliyetler, tehlikeler, kontroller ve risk satırları; Excel içe aktarma.',
      complianceRiskDashboard:
        'Risk özeti: okundu onayları, gözden geçirmesi gelenler, yetki bekleyen operasyonlar, yüksek kalan riskler ve durdurulan işler.',
      complianceRiskReports:
        'Kütüphane durumu, register uyumu ve doğrulama geçmişi; CSV dışa aktarma.',
      materialMaster: 'Kategori, kod ve ilgili ekipmanıyla malzeme kataloğu.',
      purchasingRequisitions: 'Onay akışıyla gemiden malzeme talepleri.',
      purchasingRfq: 'Teklif istekleri ve tedarikçi karşılaştırması.',
      purchasingOrders: 'Satın alma siparişleri ve durumları.',
      purchasingSuppliers: 'Tedarikçi listesi ve performansı.',
      purchasingGrn: 'Teslimat ve mal kabul.',
      purchasingStock: 'En az ve en çok seviyeleriyle eldeki stok.',
      inventorySpareParts: 'Gemideki yedek parça, sarf ve malzeme; kumanya hariç.',
      inventoryStock: 'Gemide stok giriş ve çıkış hareketleri.',
      inventoryProvision: 'Kumanya ve tüketimi.',
      inventoryVictualling: 'Aylık iaşe raporu ve kişi-gün başı oran.',
      pmsEquipment: 'Ekipman ağacı, bileşenler ve sayaçlar.',
      pmsPlan: 'Planlı bakım işleri ve aralıkları.',
      pmsPostponements: 'Ertelenen işler: gemide kaptan onayı, ofiste izleme.',
      pmsWorkOrders: 'Raporlama ve onaylarıyla iş emirleri.',
      pmsDefects: 'Arıza bildirimleri (DM-17): bildirim, giderme ve onay.',
      pmsLibrary: 'Şirketin ekipman ve bakım işi kütüphanesi; gemilere ofisten uygulanır.',
      pmsClassIntegration:
        'Tamamlanan bakım kayıtlarının her gün DNV’ye (MAD) aktarımı, eşleme ve doğrulama.',
      pmsHistory: 'Bakım geçmişi ve NR496 raporları.',
      fuelManagement: 'Yakıt tankları, alımlar, transferler, tüketim, ROB ve MRV / ETS.',
      reports: 'Her modülün yazdırılabilir ve dışa aktarılabilir raporları.',
    },
  },
  alerts: {
    title: 'Aktif Uyarılar',
    none: 'Aktif uyarı yok.',
    certificate: {
      expired: '{{certificate}}: süresi doldu',
      expiring: '{{certificate}}: süresi yakında doluyor',
      expiresIn_one: '{{certificate}}: süresi {{count}} gün sonra doluyor',
      expiresIn_other: '{{certificate}}: süresi {{count}} gün sonra doluyor',
      expiresToday: '{{certificate}}: süresi bugün doluyor',
    },
    missing_one: '{{count}} zorunlu belge eksik',
    missing_other: '{{count}} zorunlu belge eksik',
    rest: {
      violation: 'Dinlenme saatleri MLC sınırının altında',
      warning: 'Dinlenme saatleri MLC sınırına yakın',
    },
    // Gemi saati (ADR 0065 §5)
    clock: {
      upcoming: 'Gemi saati {{time}} itibarıyla {{change}} ({{from}} → {{to}})',
      pending: 'Saat değişikliği kaptanın onayını bekliyor: {{time}} itibarıyla {{change}}',
    },
    // Kontrat / MLC (ADR 0076 §4) [MLC 2006 Std A2.5.1 §2(b)]
    contract: {
      contract: {
        in_one: 'Kontrat {{count}} gün sonra bitiyor',
        in_other: 'Kontrat {{count}} gün sonra bitiyor',
        today: 'Kontrat bugün bitiyor',
        overdue: 'Kontrat bitti, kişi hâlâ gemide',
      },
      mlc: {
        in_one: 'MLC 12 ay sınırına {{count}} gün kaldı',
        in_other: 'MLC 12 ay sınırına {{count}} gün kaldı',
        today: 'MLC 12 ay sınırı bugün',
        overdue: 'MLC 12 ay sınırı aşıldı',
      },
    },
    // Tatbikat (ADR 0128 Faz 2 Ek; ADR 0156 hata düzeltmesi)
    drill: {
      overdue: '{{drill}} tatbikatı gecikti',
      due: '{{drill}} tatbikatının zamanı geldi',
      pending_review: '{{drill}} tatbikatı incelemeyi bekliyor',
      postponement: '{{drill}} tatbikatı için erteleme istendi',
    },
  },
  overview: {
    certificates: 'Belge Özeti',
    total: 'Toplam',
    valid: 'Geçerli',
    expiring: 'Dolacak',
    expired: 'Dolmuş',
    missing: 'Eksik',
    rest: 'Dinlenme Saatleri',
    restOn: '{{date}} dinlenme saatleri',
    compliant: 'Uygun',
    warning: 'Uyarı',
    violation: 'İhlal',
    incomplete: 'Kayıt yok',
    expirations: {
      title: 'Yaklaşan Son Geçerlilikler',
      name: 'Ad',
      document: 'Belge',
      expiry: 'Son Geçerlilik',
      viewAll: 'Tümünü Gör',
      none: 'Yakında süresi dolacak belge yok.',
    },
  },
  crew: {
    title: 'Personel Listesi',
    subtitle: 'Gemideki ve karadaki personel; rütbe, gemi ve tarihleriyle.',
    subtitleShip: '{{vessel}} gemisinde görevli personel.',
    summary: {
      label: 'Personel özeti',
      total: 'Toplam personel',
      onBoard: 'Gemide',
      ashore: 'Karada',
      longAshore: '{{days}}+ gündür karada',
    },
    filters: 'Personel süzgeçleri',
    vessel: 'Gemi',
    allVessels: 'Tüm gemiler',
    rank: 'Rütbe',
    allRanks: 'Tüm rütbeler',
    filter: {
      label: 'Durum',
      all: 'Tüm durumlar',
      on_board: 'Gemide',
      ashore: 'Karada',
      not_assigned: 'Atanmadı',
    },
    search: 'Personel ara...',
    add: 'Personel Ekle',
    columns: {
      photo: 'Fotoğraf',
      name: 'Ad',
      rank: 'Rütbe',
      nationality: 'Uyruk',
      status: 'Durum',
      vessel: 'Gemi',
      since: 'Başlangıç',
      days: 'Süre',
      next: 'Sonraki katılış',
      contract: 'Kontrat bitişi',
      login: 'Giriş',
      actions: 'İşlemler',
    },
    login: {
      label: 'Giriş hesabı',
      login: 'Hesap var',
      none: 'Hesap yok',
      disabled: 'Devre dışı',
      filter: { all: 'Tüm hesaplar', no_login: 'Hesap yok' },
    },
    // Kontrat bitişi ve kalan gün rozeti (ADR 0076 §5)
    contract: {
      left_one: '{{count}} gün kaldı',
      left_other: '{{count}} gün kaldı',
      today: 'Bugün bitiyor',
      overdue_one: '{{count}} gün önce bitti',
      overdue_other: '{{count}} gün önce bitti',
      mlcOverdue_one: 'MLC sınırı +{{count}} gün',
      mlcOverdue_other: 'MLC sınırı +{{count}} gün',
      mlcLimit: 'MLC sınırı {{date}}',
      noContract: 'Girilmedi',
      exceeds: 'MLC 12 ay sınırını aşıyor',
    },
    sortBy: '{{column}} sütununa göre sırala',
    // Durum yazımı Crew List, Certificates ve MLC ekranlarında tek (M6f G2-06)
    status: { on_board: 'Gemide', ashore: 'Karada', not_assigned: 'Atanmadı' },
    days_one: '{{count}} gün',
    days_other: '{{count}} gün',
    emptyTitle: 'Henüz personel yok',
    emptyText: 'Gemilerinize atanan kişiler burada görünür.',
    emptyShip: 'Bugün bu gemiye atanmış kimse yok. Atamaları ofis yapar; sonraki senkronla gelir.',
    noMatch: 'Süzgeçlere uyan personel yok.',
    noPreviousAssignment: 'Önceki görev yok',
    error: 'Personel listesi yüklenemedi.',
    table: 'Personel listesi',
    pagination: 'Personel listesi sayfaları',
    page: {
      first: 'İlk sayfa',
      previous: 'Önceki sayfa',
      next: 'Sonraki sayfa',
      last: 'Son sayfa',
    },
    showing: '{{total}} kişiden {{from}} - {{to}} gösteriliyor',
    actions: '{{name}} işlemleri',
    openProfile: 'Personel Kartı',
    openProfileOf: '{{name}} personel kartını aç',
    openCertificates: 'Sertifikalar ve Belgeler',
    openRestHours: 'Çalışma ve Dinlenme Saatleri',
  },
  certificates: {
    title: 'Sertifikalar ve Belgeler',
    subtitle:
      'Personel sertifikalarını yönetin, geçerlilik tarihlerini izleyin ve STCW ile şirket gerekliliklerine uyumu sağlayın.',
    add: 'Sertifika Ekle',
    filters: 'Sertifika süzgeçleri',
    vessel: 'Gemi',
    crewMember: 'Personel',
    allCrew: 'Tüm personel',
    certificate: 'Sertifika',
    vessels: 'Gemiler',
    ashore: 'Karada / Müsait',
    crewCount_one: '{{count}} kişi',
    crewCount_other: '{{count}} kişi',
    crewOn: '{{vessel}} personeli',
    crewAshore: 'Karadaki personel',
    searchCrew: 'Personel ara...',
    moreCrew_one: '{{count}} kişi daha',
    moreCrew_other: '{{count}} kişi daha',
    noCrew: 'Bu grupta kimse yok.',
    noCrewMatch: 'Aramaya uyan personel yok.',
    noCrewHint: 'Bugün bu gemiye atanmış kimse yok.',
    choosePerson: 'Belgelerini görmek için bir kişi seçin.',
    summary: {
      label: 'Belge özeti',
      total: 'Toplam Sertifika',
      valid: 'Geçerli',
      expiring: 'Dolacak (≤ {{days}} gün)',
      expired: 'Dolmuş',
      missing: 'Eksik',
    },
    filter: {
      label: 'Durum',
      all: 'Tüm durumlar',
      valid: 'Geçerli',
      expiring: 'Dolacak',
      expired: 'Dolmuş',
      missing: 'Eksik',
    },
    search: 'Sertifika adı ara...',
    tabs: {
      label: 'Sertifika görünümleri',
      matrix: 'Sertifika Matrisi',
      documents: 'Belgeler',
      employment: 'Görev ve Ayrılış',
      notes: 'Notlar',
    },
    columns: {
      certificate: 'Sertifika / Belge',
      category: 'Kategori',
      number: 'No.',
      issued: 'Veriliş',
      expires: 'Bitiş',
      status: 'Durum',
      file: 'Dosya',
      actions: 'İşlemler',
    },
    status: { valid: 'Geçerli', expiring: 'Dolacak', expired: 'Dolmuş', missing: 'Eksik' },
    sortBy: '{{column}} sütununa göre sırala',
    category: {
      competency: 'Yeterlik',
      gmdss: 'GMDSS',
      stcw_safety: 'STCW Güvenlik',
      security: 'Emniyet',
      medical: 'Sağlık',
      specialized: 'Uzmanlık',
      personal: 'Kişisel',
      other: 'Diğer',
    },
    noFile: 'Dosya yok',
    noExpiry: 'Süresiz',
    daysLeft_one: '{{count}} gün kaldı',
    daysLeft_other: '{{count}} gün kaldı',
    daysAgo_one: '{{count}} gün önce doldu',
    daysAgo_other: '{{count}} gün önce doldu',
    required: 'Bu rütbe için zorunlu',
    showing: '{{total}} sertifikadan {{from}} - {{to}} gösteriliyor',
    pagination: 'Sertifika sayfaları',
    page: {
      first: 'İlk sayfa',
      previous: 'Önceki sayfa',
      next: 'Sonraki sayfa',
      last: 'Son sayfa',
    },
    noMatch: 'Süzgeçlere uyan sertifika yok.',
    emptyTitle: 'Henüz sertifika yok',
    emptyText: 'Bu kişinin ilk sertifikasını ekleyin.',
    emptyShip: 'Sertifikaları ofis kaydeder; sonraki senkronla gemiye iner.',
    overview: 'Sertifika Özeti',
    categories: 'Sertifika Kategorileri',
    documentsTitle: 'Ayrı belge yok',
    documentsEmpty:
      'Pasaport, gemici cüzdanı ve diğer kişisel belgeler sertifika matrisinde listelenir. Dosya ekleri sonraki güncellemeyle gelir.',
    notesEmpty: 'Bu kişi için not yok.',
    employment: {
      vessel: 'Gemi',
      rank: 'Rütbe',
      signOn: 'Katılış',
      signOff: 'Ayrılış',
      days: 'Gemide gün',
      daysAshore: 'Karada gün',
      next: 'Sonraki görev',
    },
    details: {
      title: 'Personel Ayrıntıları',
      close: 'Personel ayrıntılarını kapat',
      open: 'Personel ayrıntıları',
      certificates: 'Sertifikalar',
      documents: 'Belgeler',
      employment: 'Görev',
      list: 'Sertifika Ayrıntıları',
      showAll: 'Tüm sertifikaları göster ({{count}})',
    },
    alerts: 'Uyarılar',
    alertExpiring_one: '{{count}} sertifikanın süresi {{days}} gün içinde doluyor!',
    alertExpiring_other: '{{count}} sertifikanın süresi {{days}} gün içinde doluyor!',
    alertExpired_one: '{{count}} sertifikanın süresi doldu!',
    alertExpired_other: '{{count}} sertifikanın süresi doldu!',
    alertMissing_one: '{{count}} zorunlu sertifika eksik!',
    alertMissing_other: '{{count}} zorunlu sertifika eksik!',
    alertNone: 'Bütün sertifikalar geçerli.',
    alertAction: 'Uyum için lütfen gerekeni yapın.',
    actions: '{{name}} işlemleri',
    edit: 'Düzelt',
    remove: 'Kaldır',
    addMissing: 'Ekle',
    removeTitle: 'Sertifikayı kaldır',
    removeText: '{{name}} listeden kaldırılacak. Kayıt ve geçmişi denetim için saklanır.',
    removeConfirm: 'Kaldır',
    error: 'Sertifikalar yüklenemedi.',
    form: {
      addTitle: 'Sertifika ekle',
      editTitle: 'Sertifikayı düzelt',
      person: '{{name}} için',
      type: 'Sertifika',
      typeRequired: 'Bir sertifika seçin.',
      typePlaceholder: 'Sertifika seçin',
      number: 'Sertifika numarası',
      issuedOn: 'Veriliş tarihi',
      expiresOn: 'Bitiş tarihi',
      expiresHint: 'Belgenin süresi yoksa boş bırakın.',
      issuedBy: 'Veren kurum',
      save: 'Kaydet',
      cancel: 'Vazgeç',
    },
  },
  restHours: {
    // Gemi saati değişikliği (ADR 0065 §7)
    clock: restHoursClockTr,
    title: 'Çalışma ve Dinlenme Saatleri (MLC)',
    subtitle:
      'Çalışma saatlerini ve dinlenme dönemlerini izleyin, MLC gerekliliklerine uyumu sağlayın.',
    vessel: 'Gemi',
    date: 'Tarih',
    dateCard: 'Seçili gün',
    previousDay: 'Önceki gün',
    nextDay: 'Sonraki gün',
    summary: {
      label: '{{date}} uyumu',
      total: 'Toplam Personel',
      compliant: 'Uygun',
      warning: 'Uyarı',
      violation: 'İhlal',
      incomplete: 'Kayıt yok',
    },
    crewList: 'Personel Listesi',
    searchCrew: 'Personel ara...',
    noCrew: 'Seçili gün bu gemide personel yok.',
    noCrewMatch: 'Aramaya uyan personel yok.',
    choosePerson: 'Aylık kaydını görmek için bir kişi seçin.',
    noVessels: 'Çalışma ve dinlenme saatlerini görmek için gemi ekleyin.',
    status: {
      compliant: 'Uygun',
      warning: 'Uyarı',
      violation: 'İhlal',
      incomplete: 'Kayıt yok',
    },
    today: 'Bugün',
    work: 'Çalışma',
    rest: 'Dinlenme',
    mlcStatus: 'MLC Durumu',
    rest24h: '24 saat dinlenme',
    rest7d: '7 gün dinlenme',
    requiredShort: '(Gerekli)',
    required: 'Gerekli',
    tabs: {
      label: 'Çalışma ve dinlenme görünümleri',
      daily: 'Günlük Çizelge',
      weekly: 'Haftalık Görünüm',
      monthly: 'Aylık Takvim',
      certificates: 'Sertifikalar',
      notes: 'Notlar',
      short: {
        daily: 'Günlük',
        weekly: 'Haftalık',
        monthly: 'Aylık',
        certificates: 'Sertifikalar',
        notes: 'Notlar',
      },
    },
    view: 'Görünüm',
    view24: '24 saat',
    timeline: '{{date}} çalışma ve dinlenme, gemi saati',
    segment: '{{kind}} {{from}}–{{to}} ({{duration}})',
    columns: {
      date: 'Tarih',
      start: 'Başlangıç',
      end: 'Bitiş',
      duration: 'Süre',
      activity: 'Faaliyet',
      location: 'Yer',
      note: 'Notlar',
      work: 'Çalışma',
      rest: 'Dinlenme',
      rest7d: '7 Gün Dinlenme',
      rest24h: '24 saat dinlenme',
      status: 'Durum',
    },
    activity: {
      watch: 'Vardiya',
      anchor_watch: 'Demir Vardiyası',
      maneuvering: 'Manevra',
      port_operations: 'Liman Operasyonu',
      cargo: 'Yük Operasyonu',
      maintenance: 'Bakım',
      drill: 'Tatbikat',
      emergency: 'Acil Durum',
      other: 'Diğer',
      rest: 'Dinlenme',
    },
    shortBreak: 'Kısa ara — dinlenme sayılmaz',
    now: 'Şimdi (gemi saati)',
    periodsError: 'Çalışma dönemleri okunamadı.',
    periodsTable: 'Çalışma ve dinlenme dönemleri',
    weeklyTable: 'Son 7 gün',
    month: {
      previous: 'Önceki ay',
      next: 'Sonraki ay',
      table: '{{month}} çalışma ve dinlenme saatleri',
      noWork: 'Çalışma kaydı yok',
      upcoming: 'Yaklaşan',
      band: 'Çalışma saatleri, gemi saati',
      empty: '{{month}} için kayıtlı saat yok',
      emptyText: 'Saatler gemide girildikçe günler burada görünür.',
      record: 'Kayıt:',
      hash: 'İçerik hash {{hash}}',
      exception: 'İstisna',
      exceptions_one: '{{count}} istisna (MLC A2.3 §14) — kaptan onaylarken imzalar',
      exceptions_other: '{{count}} istisna (MLC A2.3 §14) — kaptan onaylarken imzalar',
      signatures: 'İmzalar',
      notSigned: 'Henüz imzalanmadı. Ay bitince imzalanabilir.',
      signed: '{{name}} imzaladı (sürüm {{revision}})',
      approved: '{{name}} onayladı',
      returned: '{{name}} iade etti',
      sign: 'Ayı imzala',
      review: 'Ayı incele',
      signTitle: '{{month}} imzası — {{name}}',
      reviewTitle: '{{month}} incelemesi — {{name}}',
      signText: 'İmzalayarak bu ayın saatlerinin doğru olduğunu onaylarsınız (MLC A2.3 §12).',
      reviewText: 'Kaydı onaylayın ya da gerekçeyle iade edin.',
      decision: 'Karar',
      approve: 'Onayla',
      return: 'İade et',
      reason: 'İade gerekçesi',
      acknowledge_one: 'Bu ayın {{count}} istisnasını imzalıyorum (MLC A2.3 §14).',
      acknowledge_other: 'Bu ayın {{count}} istisnasını imzalıyorum (MLC A2.3 §14).',
      password: 'Parola',
      confirm: 'Onayla',
      error: 'Aylık kayıt okunamadı.',
      status: {
        draft: 'İmzalanmadı',
        pending: 'Kaptan onayında',
        approved: 'Onaylandı',
        returned: 'İade edildi',
        reapproval_pending: 'Değişti — yeniden imza',
      },
      errors: {
        INVALID_CREDENTIALS: 'Parola yanlış.',
        REAUTHENTICATION_REQUIRED: 'Şirketiniz her onayda parola istiyor. Parolanızı girin.',
        TOO_MANY_ATTEMPTS: 'Çok fazla deneme. 15 dakika bekleyip yeniden deneyin.',
        CONTENT_CHANGED: 'Bu arada saatler değişti. Kapatıp yeniden inceleyin.',
        MONTH_NOT_ENDED: 'Ay bitince imzalanabilir.',
        ALREADY_SUBMITTED: 'Bu ay zaten imzalı.',
        NOT_PENDING: 'Bu ay karar beklemiyor.',
        NOT_APPROVER: 'Bu kaydı yalnız kaptan onaylar.',
        RETURN_REASON_REQUIRED: 'İade gerekçesini yazın.',
        EXCEPTIONS_NOT_ACKNOWLEDGED: 'Bu ayın istisnalarını imzalayın.',
        APPROVAL_RULE_MISSING: 'Onay matrisinde aylık kayıt kuralı yok. Ofise başvurun.',
        FORBIDDEN: 'Bunu yapmaya yetkiniz yok.',
      },
    },
    pdf: {
      download: 'PDF indir',
      print: 'Yazdır',
      error: 'PDF oluşturulamadı.',
      errors: {
        OPEN_FAILED:
          'Bu bilgisayarda PDF dosyalarını açacak bir uygulama bulunamadı. “PDF indir” ile dosyayı kaydedip başka bir uygulama ya da bilgisayarla yazdırın.',
        POPUP_BLOCKED:
          'Tarayıcı yeni sekmeyi engelledi. Bu site için açılır pencerelere izin verin ya da “PDF indir”i kullanın.',
      },
      title: 'Çalışma ve dinlenme saatleri kaydı',
      subtitle: 'ILO/IMO biçimi · MLC 2006 Standart A2.3 · STCW Kod A-VIII/1',
      vessel: 'Gemi adı',
      imo: 'IMO numarası',
      seafarer: 'Gemi adamı (adı soyadı)',
      rank: 'Görev / rütbe',
      month: 'Ay ve yıl',
      timeZone: 'Gemi saat dilimi',
      status: 'Kayıt durumu',
      day: 'Gün',
      grid: 'Çalışma saatleri (taralı), gemi saati',
      periods: 'Çalışma dönemleri',
      work: 'Çalışma',
      rest: 'Dinlenme',
      rest24h: '24 saatte dinlenme',
      rest7d: '7 günde dinlenme',
      remarks: 'Açıklamalar',
      notRecorded: 'Kayıt yok',
      total: 'Aylık toplam',
      summary_one:
        '{{recorded}} gün kayıtlı · {{violations}} gün ihlal · {{warnings}} gün uyarı · {{count}} istisna',
      summary_other:
        '{{recorded}} gün kayıtlı · {{violations}} gün ihlal · {{warnings}} gün uyarı · {{count}} istisna',
      clockNotes: 'Gemi saati değişiklikleri',
      legend:
        'V = ihlal, W = uyarı, E = istisna (MLC A2.3 §14), kaptan imzalı. Sınırlar: herhangi 24 saatte en az 10 saat ve herhangi 7 günde en az 77 saat dinlenme; dinlenme en çok iki parça, biri en az 6 saat; dinlenmeler arası en çok 14 saat (MLC A2.3 §5–6; STCW A-VIII/1).',
      rules: {
        MIN_REST_24H: '24 saatte dinlenme',
        MIN_REST_7D: '7 günde dinlenme',
        MAX_WORK_24H: '24 saatte çalışma',
        MAX_WORK_7D: '7 günde çalışma',
        REST_PERIODS_MAX_TWO: 'Dinlenme ikiden çok parça',
        REST_PERIOD_MIN_6H: '6 saatlik dinlenme yok',
        REST_INTERVAL_MAX_14H: 'Dinlenmeler arası süre',
      },
      electronic: 'Felixmate imzaları',
      seafarerSigned: 'Gemi adamı imzaladı: {{name}}, {{at}} (sürüm {{revision}})',
      notSigned: 'Gemi adamı: imzalamadı',
      masterApproved: 'Kaptan onayladı: {{name}}, {{at}}',
      masterReturned: 'Kaptan iade etti: {{name}}, {{at}}',
      notApproved: 'Kaptan: onaylamadı',
      earlier: 'kaydın önceki bir sürümüne aittir',
      hash: 'İçerik özeti (SHA-256)',
      declaration:
        'Bu kaydın ilgili gemi adamının çalışma ya da dinlenme saatlerini doğru yansıttığını kabul ederim.',
      masterBox: 'Kaptan ya da kaptanın yetkilendirdiği kişi',
      seafarerBox: 'Gemi adamı',
      name: 'Adı soyadı',
      signature: 'İmza',
      date: 'Tarih',
      copyNote: 'Bu kaydın bir kopyası gemi adamına verilir (MLC A2.3 §12).',
      footer: '{{name}} · {{month}} · Felixmate · oluşturma {{at}} · sayfa {{page}} / {{pages}}',
      fileName: 'dinlenme-saatleri',
    },
    edit: {
      open: 'Düzenle',
      title: 'Günlük Çalışma ve Dinlenme Kaydı',
      who: '{{name}} ({{rank}})',
      timePart: '{{field}} – {{part}}',
      add: 'Dönem ekle',
      addTitle: 'Yeni çalışma dönemi',
      editTitle: 'Çalışma dönemini düzelt',
      nextDayHint: 'Bitiş başlangıçtan önceyse ertesi gün biter',
      noteHint: 'Acil durumda zorunlu (MLC A2.3 §14)',
      lockedNoteHint: 'Zorunlu: imzalı ayı düzeltmenin gerekçesi (MLC A2.3 §12)',
      save: 'Kaydet',
      done: 'Tamam',
      close: 'Kapat',
      cancel: 'Vazgeç',
      actions: 'İşlemler',
      editPeriod: '{{from}}–{{to}} dönemini düzelt',
      removePeriod: '{{from}}–{{to}} dönemini kaldır',
      removeQuestion: '{{from}}–{{to}} dönemi kaldırılsın mı? Kayıt denetim için saklanır.',
      confirmRemove: 'Kaldır',
      previousDay: '(önceki gün)',
      totalWork: 'Toplam Çalışma Saati',
      totalRest: 'Toplam Dinlenme Saati',
      lockedTitle: 'Bu ay imzalandı.',
      lockedText:
        'Yalnız kaptan, gerekçesini nota yazarak düzeltebilir; ay yeniden onaya düşer. İmzalı ayın dönemleri kaldırılamaz.',
      lockedRemove: 'İmzalı ayın dönemleri kaldırılamaz.',
      mlcNote:
        'Çalışma ve dinlenme saatleri MLC 2006 Standart A2.3 ve STCW A-VIII/1 uyarınca, gemi saatiyle kaydedilir.',
      errors: {
        END_NOT_AFTER_START: 'Bitiş başlangıçtan farklı olmalı.',
        TIME_SKIPPED: 'Bu saat yaşanmadı: gemi saati ileri alındı.',
        FUTURE_DATE: 'Gelecek için saat girilemez.',
        EMERGENCY_REASON_REQUIRED: 'Acil durum çalışmasının gerekçesini yazın.',
        OVERLAPPING_PERIODS: 'Bu dönem başka bir çalışma dönemiyle çakışıyor.',
        NO_ASSIGNMENT: 'Kişi o gün bu gemide görevli değil.',
        MONTH_LOCKED: 'Bu ay imzalandı. Düzeltme için kaptana başvurun.',
        MONTH_LOCK_REASON_REQUIRED: 'Bu ay imzalı: düzeltmenin gerekçesini nota yazın.',
        ROW_VERSION_CONFLICT: 'Bu dönemi başkası değiştirdi. Kapatıp yeniden açın.',
        FORBIDDEN: 'Yalnız kendi saatlerinizi girebilirsiniz.',
        TOO_LONG: 'Bu metin çok uzun.',
        VALIDATION_FAILED: 'Alanları kontrol edin.',
        GENERIC: 'Bir şeyler ters gitti. Lütfen yeniden deneyin.',
      },
    },
    readOnly: 'Saatler gemide girilir ve sonraki senkronla gelir.',
    certificatesTitle: 'Sertifikalar kendi ekranında',
    certificatesLink: '{{name}} sertifikalarını aç',
    certificatesText: 'Personel › Sertifikalar ve Belgeler ekranına bakın.',
    notesEmpty: 'Bu gün için not yok.',
    limits: 'MLC Temel Sınırları',
    limit: {
      minRest24h: 'En az dinlenme (24 saat)',
      maxWork24h: 'En çok çalışma (24 saat)',
      minRest7d: 'En az dinlenme (7 gün)',
      maxWork7d: 'En çok çalışma (7 gün)',
    },
    hoursValue: '{{hours}} saat',
    rulesLink: 'MLC kurallarını göster',
    rulesText:
      'MLC 2006 Std A2.3 §5–6 ve STCW A-VIII/1: her 24 saatte en az 10, her 7 günde en az 77 saat dinlenme; dinlenme en çok iki parçada, biri en az 6 saat; iki dinlenme arası en çok 14 saat.',
    compliance: 'MLC Uyumu',
    restIn24h: 'Dinlenme (24 saat)',
    remaining: 'Kalan',
    weekSummary: '7 Günlük Özet',
    restPeriods: 'Dinlenme Dönemleri (24 saat)',
    noRestPeriods: 'Kayıtlı dinlenme dönemi yok',
    weekChart: '7 Günlük Çalışma ve Dinlenme',
    weekBar: '{{date}}: çalışma {{work}}, dinlenme {{rest}}',
    distribution: 'İş Türü Dağılımı (7\u00a0gün)',
    totalWork: 'Toplam çalışma',
    noWork: 'Son 7 günde çalışma kaydı yok.',
    logs: 'Son Kayıtlar',
    logStart: 'Çalışma başladı - {{activity}}',
    logEnd: 'Çalışma bitti - {{activity}}',
    logsEmpty: 'Son 7 günde kayıt yok.',
    incompleteTitle: 'Bu günün kaydı eksik.',
    incompleteText: 'Gün tam kaydedilmeden MLC uyumu değerlendirilemez.',
    noFindings: 'Bütün MLC gereklilikleri sınırlar içinde.',
    noViolations: 'İhlal yok.',
    exception: 'Acil durum — kaptanın imzalı istisnası gerekir',
    rule: {
      MIN_REST_24H: '24 saatte dinlenme {{value}} sa (en az {{limit}} sa)',
      MIN_REST_7D: '7 günde dinlenme {{value}} sa (en az {{limit}} sa)',
      MAX_WORK_24H: '24 saatte çalışma {{value}} sa (en çok {{limit}} sa)',
      MAX_WORK_7D: '7 günde çalışma {{value}} sa (en çok {{limit}} sa)',
      REST_PERIODS_MAX_TWO: 'Dinlenme {{value}} parçaya bölünmüş (en çok {{limit}})',
      REST_PERIOD_MIN_6H: 'En uzun dinlenme {{value}} sa (en az {{limit}} sa)',
      REST_INTERVAL_MAX_14H: 'İki dinlenme arası {{value}} sa (en çok {{limit}} sa)',
    },
    error: 'Çalışma ve dinlenme saatleri yüklenemedi.',
  },
  voyage: {
    // Gemi saati kaydıyla tutarsız fark (ADR 0065 §8)
    clockHint:
      'Gemi Saati Kaydı: bu anda {{log}}; bu rapor {{report}} kullanıyor. Farkı kontrol edin; rapor kendiliğinden değiştirilmez.',
    noon: {
      title: 'Öğle Raporu',
      description:
        'Öğle raporunu geminin güncel verileriyle doldurun. Bilgiler sefer, performans ve uyum raporlarında kullanılır.',
      descriptionOffice:
        'Öğle raporları gemide girilir ve gönderilir. Ofis gönderilmiş raporu görür.',
      tabs: {
        voyage: 'Sefer',
        navigation: 'Seyir',
        machinery: 'Makine',
        fuel: 'Yakıt ve ROB',
        weather: 'Hava ve Deniz',
        attachments: 'Ekler',
      },
      header: {
        voyageNo: 'Sefer No',
        leg: 'Bacak',
        from: 'Nereden',
        to: 'Nereye',
        reportTime: 'Rapor Tarihi ve Saati',
      },
      status: {
        draft: 'Taslak',
        submitted: 'Gönderildi',
        reopened: 'Yeniden açıldı',
        void: 'İptal',
        new: 'Yeni',
      },
      voyageTab: {
        title: 'Sefer',
        charterParty: 'Çarter Sözleşmesi',
        charterer: 'Kiracı',
        plannedDistance: 'Planlanan Mesafe',
        plannedEtd: 'Tahmini Kalkış Zamanı (ETD)',
        plannedEta: 'Tahmini Varış Zamanı (ETA)',
        cpSpeed: 'CP Hızı (Yüklü / Balast)',
        cpConsumption: 'CP Tüketimi (Yüklü / Balast)',
        cpWeather: 'CP Hava Sınırı',
        voyageStatus: 'Sefer Durumu',
        started: 'Sefer Başlangıcı',
        fuel: 'Yakıt Türü (AM / YM)',
        beaufortMax: 'Bofor {{value}}, Hs {{height}} m',
      },
      navigation: {
        title: 'Seyir',
        position: 'Mevki ve Rota',
        latitude: 'Enlem',
        longitude: 'Boylam',
        course: 'Rota (°)',
        heading: 'Hakiki Pruva (°)',
        sog: 'Yere Göre Hız (kn)',
        stw: 'Suya Göre Hız (kn)',
        distances: 'Mesafe ve Hız',
        distanceSinceLast: 'Son Rapordan Bu Yana Mesafe (nm)',
        distanceThroughWater: 'Suya Göre Mesafe (nm)',
        distanceOverGround: 'Yere Göre Mesafe (nm)',
        distanceToGo: 'Kalan Mesafe (nm)',
        averageSpeed: 'Ortalama Hız (kn)',
        nextWaypoint: 'Sonraki Yol Noktası',
        steaming: 'Son Rapordan Bu Yana Seyir Süresi',
        previousTime: 'Önceki Rapor Zamanı (COSP / Öğle)',
        currentTime: 'Bu Rapor Zamanı',
        currentTimeZone: 'Bu Rapor Zamanı (yerel, {{zone}})',
        steamingTime: 'Seyir Süresi (sa)',
        steamingNote: 'Önceki rapor zamanına göre kendiliğinden hesaplanır.',
        noPrevious: 'Önceki rapor yok',
        timeZone: 'Saat Dilimi',
        utcOffset: 'UTC Farkı',
        utcNote: 'Listeden seçin ya da ±SS:DD yazın.',
        remarks: 'Seyir Notları',
        remarksPlaceholder: 'Seyir notlarını girin…',
      },
      machinery: {
        title: 'Makine',
        performance: 'Ana Makine Performansı',
        mainEngine: 'Ana Makine',
        engineSpeed: 'Makine Devri (RPM)',
        engineLoad: 'Makine Yükü',
        shaftSpeed: 'Şaft Devri (RPM)',
        runningHours: 'Çalışma Saati',
        power: 'Güç (kW)',
        status: 'Durum',
        propeller: 'Pervane ve Hatve',
        propellerType: 'Pervane Türü',
        pitch: 'Pervane Hatvesi',
        diameter: 'Pervane Çapı',
        speed: 'Hız Hesabı',
        theoreticalSpeed: 'Teorik Hız (kn)',
        theoreticalSpeedShort: 'Teorik Hız',
        theoreticalFormula: 'Teorik hız = pervane hatvesi × şaft devri × 60 / 1852',
        stw: 'Suya Göre Hız (STW) (kn)',
        sog: 'Yere Göre Hız (SOG) (kn)',
        current: 'Akıntı (kn)',
        slip: 'Pervane Kayması (%)',
        slipShort: 'Kayma (%)',
        slipSog: 'SOG’ye Göre Kayma (%)',
        currentEffect: 'Akıntı Etkisi (STW − SOG)',
        slipSogNote:
          'Kayma (%) suya göre hızla, SOG’ye göre kayma yere göre hızla hesaplanır. Akıntı etkisi = (STW − SOG) / STW: akıntı yardım ediyorsa negatif.',
        slipRangeNote:
          'Yüklü geminin olağan havada görünür kayması; aralık dışındaysa devir, hatve ve suya göre hız girişlerini denetleyin.',
        slipDetails: 'Kayma Hesabı Ayrıntısı',
        slipFormula: '(Teorik Hız − Suya Göre Hız) / Teorik Hız × 100',
        difference: 'Fark',
        slipNormal: 'Kayma olağan aralıkta.',
        slipOut: 'Kayma olağan aralığın dışında.',
        slipRange: 'Olağan aralık: %{{from}} – %{{to}}',
        auxiliary: 'Yardımcı Makineler',
        auxiliaryTable: 'Yardımcı makineler tablosu',
        runningHoursShort: 'Çalışma Saati',
        hoursSinceLast: 'Son Rapordan Beri Saat',
        hoursSinceLastShort: 'Son Rapordan Beri (s)',
        runningHoursOf: '{{name}} ÇS',
        loadShort: 'Yük',
        powerShort: 'Güç',
        fuelConsumption: 'Yakıt Tüketimi',
        fuelOf: 'Yakıt Tüketimi ({{fuel}})',
        remarksPlaceholder: 'Makine notlarını girin…',
        equipment: 'Ekipman',
        rpm: 'Devir',
        load: 'Yük (%)',
        consumption: 'Yakıt Tüketimi (MT)',
        remarks: 'Not',
        machineryRemarks: 'Makine Notları',
        addAuxiliary: 'Ekipman ekle',
        removeRow: 'Satırı kaldır',
        generators: 'Jeneratörler',
        boilerOthers: 'Kazan ve Diğerleri',
        noAuxiliary: 'Yardımcı makine girilmedi.',
        consumption24h: 'Yakıt Tüketimi (24 sa)',
      },
      fuel: {
        title: 'Yakıt ve ROB',
        fuelType: 'Yakıt Türü',
        opening: 'Açılış ROB',
        consumption: 'Tüketim',
        bunkering: 'İkmal',
        closing: 'Kapanış ROB',
        lubes: 'Yağlar ve Diğerleri',
        freshWater: 'Tatlı Su',
        rob: 'ROB',
        produced: 'Üretilen',
        bunkered: 'İkmal',
        addFuel: 'Yakıt ekle',
        addLube: 'Yağ ekle',
        addFreshWater: 'Tatlı su ekle',
        name: 'Ad',
        unit: 'MT',
        noFuel: 'En az bir yakıt girin.',
      },
      fuelSummary: {
        title: 'Yakıt Tüketimi ve ROB',
        table: 'Yakıta göre tüketim ve ROB',
        consumption: 'Tüketim (MT)',
        rob: 'ROB (MT)',
        total: 'Toplam',
        robFuel: 'ROB – Yakıt (MT)',
        robLube: 'ROB – Yağ (MT)',
        robTotal: 'Toplam ROB (MT)',
      },
      weather: {
        title: 'Hava ve Deniz',
        wind: 'Rüzgâr',
        direction: 'Yön (°)',
        speed: 'Hız (kn)',
        beaufort: 'Bofor',
        sea: 'Deniz',
        seaState: 'Deniz Durumu (Douglas)',
        swellDirection: 'Ölü Dalga Yönü (°)',
        swellHeight: 'Ölü Dalga Yüksekliği (m)',
        swellPeriod: 'Ölü Dalga Periyodu (s)',
        weather: 'Hava',
        condition: 'Durum',
        visibility: 'Görüş (nm)',
        airTemp: 'Hava Sıcaklığı (°C)',
        seaTemp: 'Deniz Suyu Sıcaklığı (°C)',
        pressure: 'Basınç (hPa)',
        current: 'Akıntı',
        relation: 'Göreli',
        remarks: 'Hava Notları',
        short: {
          wind: 'Rüzgâr',
          direction: 'Yön',
          speed: 'Hız',
          beaufort: 'Bofor',
          sea: 'Deniz',
          seaState: 'Deniz Durumu',
          swellDirection: 'Ölü Dalga Yönü',
          swellHeight: 'Ölü Dalga Yüksekliği',
          swellPeriod: 'Ölü Dalga Periyodu',
          weather: 'Hava',
          visibility: 'Görüş',
          airTemp: 'Hava Sıcaklığı',
          seaTemp: 'Deniz Suyu Sıcaklığı',
          pressure: 'Basınç',
          current: 'Akıntı',
        },
      },
      relation: { head: 'Baştan', following: 'Kıçtan', beam: 'Bordadan' },
      propellerType: { fixed: 'Sabit Hatveli', controllable: 'Değişken Hatveli' },
      machineryStatus: {
        running: 'Çalışıyor',
        standby: 'Beklemede',
        stopped: 'Durdu',
        not_in_use: 'Kullanılmıyor',
      },
      attachments: {
        title: 'Ekler',
        pdf: 'Öğle Raporu PDF',
        notGenerated: 'Oluşturulmadı',
        supporting: 'Destekleyici Belgeler',
        files: '{{count}} dosya',
        upload: 'Yükle',
        uploadLater: 'Sefer raporlarına dosya ekleme ekler adımıyla (M11c) gelir.',
        pdfReady: 'A4, LT ve UTC, onay bilgisi',
        print: 'Yazdır / PDF',
        uploadTypes: 'Fotoğraf ya da belge yükle (JPG, PNG, PDF; en çok 25 MB)',
        saveFirst: 'Önce taslağı kaydedin, sonra dosya ekleyin.',
        locked: 'Gönderilmiş rapor kilitli: dosya, kaptan raporu yeniden açtıktan sonra eklenir.',
        uploaded: '{{name}} eklendi.',
        drop: 'Dosyaları buraya sürükleyin ya da yüklemek için tıklayın',
        types: '(PDF, JPG, PNG, DOCX)',
        attached: 'Ekli Dosyalar ({{count}})',
        none: 'Henüz dosya eklenmedi.',
        later:
          'Sefer raporlarına dosya ekleme M11c ile gelir. Raporun PDF çıktısını rapor modülü üretir.',
      },
      // Referans paneli (ADR 0059 §5; g3 §2, §3, §7)
      reference: {
        title: 'Seyir Referansı',
        cosp: {
          title: 'COSP Referansı',
          time: 'COSP Tarihi / Saati',
          position: 'COSP Konumu',
          elapsed: 'COSP’tan Beri Süre',
          distance: 'COSP’tan Beri Mesafe',
          avgSpeed: 'Ortalama Hız',
          none: 'Bu rapordan önce açık seyir (COSP) yok.',
        },
        previous: {
          title: 'Önceki Rapor',
          type: 'Önceki Rapor Türü',
          time: 'Önceki Rapor Tarihi / Saati',
          elapsed: 'Son Rapordan Beri Geçen Süre',
          none: 'Bu seferde önceki rapor yok.',
        },
        eta: {
          title: 'ETA / Liman Bilgisi',
          nextPort: 'Sonraki Liman',
          chartArea: 'Harita Datumu / Bölge',
          eta: 'Sonraki Limana ETA',
          total: 'Toplam Sefer Mesafesi',
          run: 'Koşulan Mesafe (sefer)',
          remaining: 'Kalan Mesafe',
          suggested: '{{speed}} kn ile ETA',
          apply: 'Önerilen ETA’yı kullan',
        },
      },
      cp: {
        title: 'Çarter Sözleşmesi Performansı',
        status: 'Çarter Durumu',
        statuses: { on_hire: 'Kirada (On Hire)', off_hire: 'Kira Dışı (Off Hire)' },
        plannedSpeed: 'Planlanan Hız',
        actualSpeed: 'Gerçekleşen Hız',
        plannedConsumption: 'Planlanan Tüketim',
        actualConsumption: 'Gerçekleşen Tüketim',
        within: 'Çarter sözleşmesi sınırları içinde.',
        outside: 'Çarter sözleşmesi sınırları dışında.',
        partial: 'Hız CP içinde · tüketim yok.',
        unknown: 'Yük durumu bilinmiyor: COSP raporunda girin.',
        perDay: '{{value}} MT/gün',
      },
      mlc: {
        title: 'MLC Uyumu',
        rest24h: '24 sa Dinlenme',
        rest7d: '7 gün Dinlenme',
        compliant: 'Uyumlu',
        warning: 'Uyarı',
        violation: 'İhlal',
        incomplete: 'Eksik',
        allWithin: 'Bütün sınırlar MLC gereklerinin içinde.',
        notAll: 'Bazı sınırlar karşılanmıyor: Çalışma ve Dinlenme Saatleri ekranına bakın.',
        noRecords: 'Bu gün için dinlenme saati kaydı yok.',
        viewDetails: 'Ayrıntılar',
        worstOf: 'Gemide en az dinlenen',
      },
      summary: {
        title: 'Hızlı Özet',
        work24h: 'Toplam Çalışma (24 sa)',
        rest24h: 'Toplam Dinlenme (24 sa)',
        work7d: 'Toplam Çalışma (7 gün)',
        rest7d: 'Toplam Dinlenme (7 gün)',
      },
      alerts: {
        title: 'Uyarılar ve Bildirimler',
        none: 'Etkin uyarı yok.',
        slip: 'Pervane kayması %{{value}}, olağan aralığın (%5–15) dışında.',
        cpSpeed: 'Ortalama hız {{value}} kn, CP hızının ({{limit}} kn) altında.',
        cpWeather: 'Bofor {{value}}, CP hava sınırını ({{limit}}) aşıyor.',
        mlc: 'Dinlenme saatleri: bütün personel MLC sınırları içinde değil.',
      },
      actions: {
        saveDraft: 'Taslağı Kaydet',
        submit: 'Öğle Raporunu Gönder',
        reopen: 'Düzelt (yeniden aç)',
        newReport: 'Yeni rapor',
        print: 'Yazdır',
        preview: 'Önizle',
        printLater: 'Yazdırma ve önizleme rapor modülüyle gelir.',
        printPdf: 'Yazdır / PDF',
      },
      machinerySummary: {
        title: 'Hızlı Özet',
        engineLoad: 'Toplam Makine Yükü',
        slip: 'Kayma',
        consumption: 'Yakıt Tüketimi',
        rob: 'ROB (Toplam)',
      },
      navigationStatus: {
        title: 'Seyir Durumu',
        position: 'Mevki',
        courseSpeed: 'Rota / Hız',
        weather: 'Hava',
        wind: 'Rüzgâr',
        seaState: 'Deniz Durumu',
        current: 'Akıntı',
      },
      noRemarks: 'Not yok',
      noVoyageTitle: 'Süren sefer yok',
      noVoyageShip:
        'Henüz sefer yok. Kalkış raporunu Sefer › Raporlar › Tüm Raporlar ▸ Yeni Rapor altından girin; sefer kalkıştan başlatılır.',
      noVoyageOffice: 'Seferler gemide planlanır; senkrondan sonra burada görünür.',
      noReportHint:
        'Öğle raporları gemide girilir; gönderilen rapor senkrondan sonra burada görünür.',
      lastSubmitted: 'Son gönderim: {{at}} (UTC)',
      by: 'gönderen {{name}}',
      saved: 'Taslak kaydedildi.',
      submitted: 'Öğle raporu gönderildi.',
      reopened: 'Rapor düzeltme için yeniden açıldı.',
      noVoyage:
        'Bu geminin süren seferi yok. Seferler gemide Sefer › Yeni Sefer altında planlanır.',
      noReport: 'Bu sefer için henüz gönderilmiş öğle raporu yok.',
      readOnly: 'Gönderilmiş rapor kilitlidir. Kaptan gerekçe yazarak yeniden açabilir.',
      error: 'Öğle raporu yüklenemedi.',
      retry: 'Yeniden dene',
      reopenDialog: {
        title: 'Gönderilmiş raporu düzelt',
        body: 'Rapor düzeltme için yeniden açılır. Değişikliklerden sonra yeniden gönderin: yeni revizyon olur, gönderilmiş sürüm geçmişte kalır.',
        reason: 'Gerekçe',
        password: 'Parola',
        confirm: 'Yeniden aç',
        cancel: 'Vazgeç',
      },
      required: 'Zorunlu',
    },
    // Ortak rapor bölümleri (ADR 0057 §3, §5)
    sections: {
      // Kalkış ve varış (ADR 0058)
      pilot: {
        title: 'Pilot, Son Halat ve Römorkörler',
        castOff: 'Son Halat (Cast Off)',
        castOffNote:
          'Kalkışın olay zamanı son halatın alındığı andır (Cast Off). Pilotun ayrılışı ayrı bir zamandır.',
        notUsed: 'Pilot kullanılmadı (N/A)',
        onBoard: 'Pilot Bindi',
        off: 'Pilot Ayrıldı',
        tugsUsed: 'Kullanılan Römorkör Sayısı',
        tugsFromRows:
          'Sayı aşağıdaki römorkör satırlarından gelir. Römorkör kullanılmadıysa 0 girin.',
      },
      nextPort: {
        title: 'Sonraki Liman',
        port: 'Sonraki Liman',
        distance: 'Sonraki Limana Mesafe',
        eta: 'Sonraki Limana ETA',
        unknownReason: 'Sonraki liman bilinmiyor – neden',
        note: 'Sonraki limanı seçin; henüz bilinmiyorsa nedenini yazın (ör. emir bekleniyor).',
      },
      load: {
        title: 'Draft ve Yükleme Durumu',
        condition: 'Yüklü / Balast',
        airDraft: 'Hava Draftı',
        draftFwd: 'Baş Draft',
        draftAft: 'Kıç Draft',
        displacement: 'Deplasman',
      },
      cargo: {
        title: 'Yük ve Operasyon',
        operationDone: 'Bu Limandaki Yük İşlemi',
        operationPlanned: 'Planlanan Yük İşlemi',
        operations: {
          loading: 'Yüklendi',
          discharging: 'Tahliye edildi',
          both: 'Yükleme ve tahliye',
          none: 'Yük işlemi yok',
        },
        row: 'Yük {{no}}',
        type: 'Yük Türü',
        unit: 'Birim',
        units: { MT: 'MT', M3: 'm³', TEU: 'TEU', UNITS: 'Adet' },
        remove: '{{no}}. yükü sil',
        loaded: 'Yüklenen Miktar',
        discharged: 'Tahliye Edilen Miktar',
        toLoad: 'Yüklenecek',
        toDischarge: 'Tahliye Edilecek',
        add: 'Yük Ekle',
        onBoard: 'Gemideki Toplam Yük',
        onBoardUnit: 'Gemideki Yükün Birimi',
        remarks: 'Yük Açıklaması',
        note: 'Yüklenen ve tahliye edilen miktarlar yalnız bu limanındır; gemideki toplam ayrıca girilir.',
      },
      classification: {
        title: 'Kalkış Sınıflandırması',
        employment: 'İstihdam Durumu',
        employments: {
          chartered: 'Kiralı / Ticari',
          unemployed: 'Kirasız',
          owners_operation: 'Armatör işletmesi',
          maintenance: 'Bakım / Onarım / Tersane',
        },
        purpose: 'Kalkış Amacı',
        purposes: {
          cargo_voyage: 'Yük / Ticari sefer',
          repositioning: 'Konum değiştirme',
          sea_trial: 'Deneme seferi / Test',
          bunker: 'Yakıt / İkmal',
          other: 'Diğer',
        },
        purposeOther: 'Diğer amaç (açıklayın)',
        charterReference: 'Kira / Sefer Referansı',
        euRoute: 'AB Rota Taraması',
        euRoutes: {
          eu_eu: 'AB → AB',
          eu_non_eu: 'AB → AB dışı',
          non_eu_eu: 'AB dışı → AB',
          non_eu_non_eu: 'AB dışı → AB dışı',
          unknown: 'Bilinmiyor',
        },
        mrv: 'MRV İncelemesi',
        mrvStatuses: {
          not_assessed: 'Değerlendirilmedi',
          review_required: 'İnceleme gerekli',
          assessed: 'Değerlendirildi',
        },
        euRouteDerived:
          'Kalkış ve sonraki limandan türetildi. Yalnız ön taramadır: MRV kapsamı ayrıca değerlendirilir.',
        euRouteManual: 'Elle düzeltildi. Yalnız ön taramadır: MRV kapsamı ayrıca değerlendirilir.',
      },
      decision: {
        title: 'Sefer Kararı',
        question: 'Bu kalkış hangi sefere bağlı?',
        actions: { link: 'Sefere bağla', create: 'Yeni sefer başlat', none: 'Henüz sefer yok' },
        hints: {
          link: 'Kalkış süren ya da planlanan bir seferin',
          create: 'Gönderince sefer formu bu kalkıştan dolu açılır; kaydedince sefer başlar',
          none: 'Kalkış sefersiz kalır (neden zorunlu)',
        },
        voyage: 'Sefer',
        noVoyage: 'Sefer seçin',
        reason: 'Sefer açılmama nedeni',
        note: 'Her kalkış yeni sefer değildir. Sefer sonra başlatılabilir ya da bağlanabilir; gönderilmiş kalkış değişmez.',
        startTitle: 'Seferi Başlat',
        startNote:
          'Bu kalkış bir sefere bağlı değil. Kalkıştan doldurulan yeni bir sefer başlatın ya da kalkışı ve ardından gelen sefersiz raporları bir sefere bağlayın.',
        start: 'Seferi Başlat',
        linkPlanned: 'Planlanan sefer',
        link: 'Bağla',
      },
      finalCheck: {
        title: 'Son Kontrol',
        criticalOpen:
          'Gemide {{count}} kritik açık arıza var. Kalkıştan önce kısıtları kontrol edin. Bu uyarı raporu engellemez; aşağıda arıza seçerseniz kısıtlarını yazın.',
        checklist: 'Kalkış Kontrol Listesi',
        statuses: { complete: 'Tamam', incomplete: 'Eksik', not_applicable: 'Uygulanamaz' },
        record: 'Kontrol Listesi Kaydı (ISM Formları)',
        noRecords: 'Son 30 günde form kaydı yok',
        checklistRemarks: 'Kontrol Listesi Açıklaması',
        defects: 'Açık Arızalar / Kısıtlar',
        noDefects: 'Açık arıza yok',
        restrictions: 'Kısıtlar / İşletme Sınırlamaları',
      },
      portCall: {
        title: 'Liman Araması',
        call: 'Liman Araması',
        none: 'Liman araması yok',
        apply: 'Uygula',
        suggest: {
          atd: '{{port}} araması: ATD {{current}}. Son halat zamanı {{at}} (UTC) olarak ayarlansın mı?',
          ata: '{{port}} araması: ATA {{current}}. Yanaşma zamanı {{at}} (UTC) olarak ayarlansın mı?',
        },
      },
      nor: {
        title: 'NOR (Hazırlık Bildirimi)',
        tenderedAt: 'NOR Verildi',
        tenderedTo: 'Verildiği Taraf',
        acceptedAt: 'NOR Kabul Edildi',
        acceptedBy: 'Kabul Eden',
        laytime: 'Laytime Başlangıcı',
        remarks: 'NOR Açıklaması',
      },
      mooring: {
        title: 'Halatlar',
        lines: 'Halat Sayısı',
        shoreLines: 'Sahil Halatı',
        remarks: 'Halat Açıklaması',
      },
      passage: {
        title: 'Seyir (COSP → EOSP)',
        cosp: 'COSP',
        elapsed: 'Geçen Süre',
        distance: 'Toplam Mesafe',
        avgSpeed: 'Ortalama Hız',
        fuel: 'Seyirdeki yakıt tüketimi (MT)',
        atCosp: "COSP'ta",
        atEosp: "EOSP'ta",
        consumed: 'Tüketilen',
        cpSpeed: 'CP Hızı ({{load}})',
        cpAllowed: 'İzin Verilen Tüketim',
        cpActual: 'Gerçek Tüketim',
        cpDiff: 'Fark',
        note: "COSP'tan bu EOSP'a brüt değerler; duruşlar düşülmez. Kira sözleşmesi penceresi Charter Party ekranındadır.",
        noCosp: "Bu EOSP'tan önce COSP yok.",
      },
      eospRef: {
        title: 'Seyir Sonu (EOSP)',
        time: 'EOSP',
        position: 'EOSP Mevkii',
        distanceToPort: 'Limana Mesafe',
        rob: "EOSP'taki ROB (MT)",
      },
      tugs: {
        title: 'Römorkörler',
        none: 'Römorkör girilmedi. Kullanılan her römorkör için bir satır ekleyin.',
        row: 'Römorkör {{no}}',
        name: 'Römorkör Adı',
        bollardPull: 'Çekme Gücü (t)',
        alongside: 'Bağlandı (Alongside / Made Fast)',
        castOff: 'Bırakıldı (Cast Off / Let Go)',
        add: 'Römorkör Ekle',
        remove: '{{no}}. römorkörü kaldır',
        legacy: 'Römorkör bilgisi (önceki giriş): {{text}}',
      },
      rob: {
        title: 'ROB – Yakıt, Yağ ve Tatlı Su (MT)',
        type: 'Tür',
        fuel: 'Yakıt',
        lube: 'Yağ',
        water: 'Su',
        freshWater: 'Tatlı Su',
        previous: 'Önceki',
        consumed: 'Tüketilen',
        sinceLast: 'Son Rapordan Beri',
        today: 'Bugün',
        rob: 'ROB',
        addLube: 'Yağ Ekle',
        addWater: 'Tatlı Su Ekle',
        remove: '{{name}} satırını kaldır',
        note: 'Bütün miktarlar metrik ton. Önceki değer son rapordan gelir; Tüketilen boşsa Önceki − ROB olarak doldurulur.',
      },
      lubes: {
        ME_CYL: 'Ana Makine Silindir Yağı',
        ME_SYS: 'Ana Makine Sistem Yağı',
        AE_LO: 'Yardımcı Makine Yağı',
        STERN_TUBE: 'Şaft (Stern Tube) Yağı',
        HYDRAULIC: 'Hidrolik Yağ',
        OTHER: 'Diğer Yağ',
      },
      weather: {
        title: 'Hava',
        windDirection: 'Rüzgâr Yönü',
        beaufort: 'Rüzgâr Kuvveti (Bofor)',
        seaState: 'Deniz Durumu (Douglas)',
        visibility: 'Görüş',
        airTemp: 'Hava Sıcaklığı (°C)',
        seaTemp: 'Deniz Sıcaklığı (°C)',
      },
      beaufortScale: {
        '0': 'Sakin',
        '1': 'Esinti',
        '2': 'Hafif rüzgâr',
        '3': 'Tatlı rüzgâr',
        '4': 'Orta rüzgâr',
        '5': 'Sert rüzgâr',
        '6': 'Kuvvetli rüzgâr',
        '7': 'Fırtınamsı',
        '8': 'Fırtına',
        '9': 'Kuvvetli fırtına',
        '10': 'Tam fırtına',
        '11': 'Şiddetli fırtına',
        '12': 'Kasırga',
      },
      douglasScale: {
        '0': 'Sakin (ayna gibi)',
        '1': 'Sakin (kırışık)',
        '2': 'Düz',
        '3': 'Hafif dalgalı',
        '4': 'Orta dalgalı',
        '5': 'Çok dalgalı',
        '6': 'Kaba',
        '7': 'Yüksek',
        '8': 'Çok yüksek',
        '9': 'Olağanüstü',
      },
      visibilityGrades: {
        very_poor: 'Çok kötü (< 1000 m)',
        poor: 'Kötü (1000 m – 2 nm)',
        moderate: 'Orta (2–5 nm)',
        good: 'İyi (> 5 nm)',
      },
      persons: {
        title: 'Gemideki Kişiler',
        crew: 'Mürettebat',
        passengers: 'Yolcu / Diğer',
      },
      condition: {
        title: 'Gemi Durumu',
        hull: 'Gövde',
        machinery: 'Makine',
        navigation: 'Seyir Cihazları',
        safety: 'Emniyet Donanımı',
        classCertificates: 'Klas Sertifikaları',
        statutoryCertificates: 'Statutory Sertifikalar',
        remarks: 'Durum Açıklaması / Arızalar',
      },
      conditionGrades: {
        satisfactory: 'Yeterli',
        unsatisfactory: 'Yetersiz',
        not_checked: 'Kontrol edilmedi',
      },
      certificateGrades: {
        valid: 'Geçerli',
        expiring: 'Süresi doluyor',
        expired: 'Süresi geçmiş',
        not_checked: 'Kontrol edilmedi',
      },
      next: {
        title: 'Sonraki İşlem (Next Operation)',
        question: 'Gemi bundan sonra ne yapacak?',
        nextReport: 'Şimdi aç:',
        note: "Gönderim için zorunlu. Seçim raporla kaydedilir ve sıradaki raporu belirler; rapor zamanı gelince Sonraki Rapor kartından açılır. 'Şimdi aç' yalnız formu açar, kayıt oluşturmaz. Seçimi değiştirmek için kaptan raporu gerekçeyle yeniden açar.",
        operations: {
          sea_passage: 'Seyir',
          berth: 'Yanaşma',
          anchorage: 'Demirleme',
          drifting: 'Driftte Bekleme',
          strait_canal: 'Kanal / Boğaz Geçişi',
          waiting_orders: 'Emir Bekleme',
          departure: 'Kalkış',
          port_stay: 'Limanda Kal',
        },
        leadsTo: {
          sea_passage: 'COSP, Noon, EOSP',
          berth: 'Yanaşma (Varış) Raporu',
          anchorage: 'Demir, Günlük, Demir Alma',
          drifting: 'Drift Başlangıcı, Drift Günlüğü, Drift Sonu',
          strait_canal: 'Boğaz / Kanal Girişi ve Çıkışı',
          waiting_orders: 'Bekleme Başlangıcı ve Sonu',
          departure: 'Sonraki: Kalkış Raporu (rıhtım değiştirme ya da demire gitme de)',
          port_stay: 'Sonraki: Limanda Günlük (günde bir; kalkış her an girilebilir)',
        },
        continue: {
          sea_passage: {
            label: 'Seyre Devam',
            leadsTo:
              'Sonraki: Öğle Raporu ya da EOSP (ya da boğaz, kanal, demir, drift, bekleme başlangıcı)',
          },
          anchorage: {
            label: 'Demirde Kal',
            leadsTo: 'Sonraki: Demirde Günlük ya da Demir Alındı',
          },
          drifting: {
            label: 'Sürüklenmeye Devam',
            leadsTo: 'Sonraki: Sürüklenmede Günlük ya da Sürüklenme Bitti',
          },
          waiting_orders: { label: 'Emir Beklemeye Devam', leadsTo: 'Sonraki: Bekleme Bitti' },
          strait_canal: { label: 'Geçişe Devam', leadsTo: 'Sonraki: Boğaz / Kanal Çıkışı' },
        },
      },
    },
    // Ortak rapor çıktısı (ADR 0057 §7)
    pdf: {
      reportNo: 'Rapor No: {{no}}',
      noVoyage: 'Henüz sefer yok',
      amended: 'DÜZELTİLDİ',
      castOff: 'Son Halat (LT / UTC)',
      vessel: 'Gemi',
      voyage: 'Sefer No',
      from: 'Nereden',
      to: 'Nereye',
      reportTimeLt: 'Rapor Zamanı (LT)',
      reportTimeUtc: 'Rapor Zamanı (UTC)',
      position: 'Konum',
      status: 'Durum',
      approval: 'Onay',
      submittedBy: 'Gönderen',
      role: 'Rol',
      submittedAt: 'Gönderim zamanı',
      revision: 'Revizyon',
      notSubmitted: 'Gönderilmedi (taslak)',
      reopenedAt: 'Yeniden açılma',
      reopenReason: 'Gerekçe',
      approvalNote:
        'Felixmate’da elektronik olarak gönderilmiştir; onay kaydı ıslak imzanın yerine geçer.',
      draftMark: 'TASLAK – GÖNDERİLMEDİ',
      reopenedMark: 'YENİDEN AÇILDI – DÜZELTİLİYOR',
      // Gerekçeli iptal (ADR 0077 §3)
      voidMark: 'İPTAL – GEÇERSİZ',
      voidedAt: 'İptal zamanı',
      voidReason: 'İptal gerekçesi',
      printed: 'Basım {{at}}',
      page: 'Sayfa {{page}} / {{pages}}',
      error: 'PDF üretilemedi.',
    },
    // Seferin günlük raporları (ADR 0059): limanda, demirde, sürüklenmede
    daily: {
      reference: {
        port_daily: 'Yanaşma Raporundan (otomatik)',
        anchorage_daily: 'Demirleme Raporundan (otomatik)',
        drift_daily: 'Drift Başlangıcından (otomatik)',
        allFast: 'All Fast (Tarih / Saat)',
        firstLine: 'İlk Halat Karada',
        pilotOff: 'Pilot Ayrılış (Tarih / Saat)',
        tugs: 'Römorkörler (son)',
        started: { anchorage_start: 'Demir Atıldı', drift_start: 'Drift Başladı' },
        position: 'Konum',
        reason: 'Neden',
        none: {
          port_daily: 'Bu rapordan önce yanaşma raporu yok.',
          anchorage_daily: 'Bu rapordan önce demirleme raporu yok.',
          drift_daily: 'Bu rapordan önce drift başlangıç raporu yok.',
        },
      },
      sinceLast: {
        type: 'Son Rapor Türü',
        time: 'Son Rapor Tarihi / Saati',
        elapsed: 'Son Rapordan Beri Geçen Süre',
      },
      location: {
        title: 'Konum Durumu',
        port: {
          port_daily: 'Liman',
          anchorage_daily: 'Liman / Demir Yeri',
          drift_daily: 'En Yakın Liman',
        },
        area: {
          port_daily: 'Terminal / Rıhtım',
          anchorage_daily: 'Demir Sahası',
          drift_daily: 'Drift Sahası',
        },
        activity: 'Faaliyet Durumu',
        berthSide: 'Yanaşma Tarafı',
      },
      activities: {
        alongside: 'Rıhtımda (All Fast)',
        cargo_operation: 'Yük Operasyonu',
        bunkering: 'Yakıt İkmali',
        repairs: 'Onarım / Bakım',
        waiting: 'Bekleme',
        at_anchor: 'Demirde',
        drifting: 'Sürüklenmede',
        other: 'Diğer',
      },
      berthSides: { port: 'İskele Taraf', starboard: 'Sancak Taraf' },
      etd: {
        title: 'ETD',
        etd: 'Tahmini Kalkış Zamanı',
        remarks: 'ETD Açıklaması',
        note: 'Raporun yerel saatiyle; ETD ileri bir zaman olabilir.',
      },
      cargo: {
        title: 'Yük / Operasyon',
        loadCondition: 'Gemi Durumu',
        operation: 'Operasyon',
        operations: {
          loading: 'Yükleme',
          discharging: 'Tahliye',
          both: 'Yükleme ve tahliye',
          none: 'Yük operasyonu yok',
        },
        cargoType: 'Yük',
        unit: 'Birim',
        planned: 'Planlanan Miktar',
        sinceLast: 'Son Rapordan Beri Elleçlenen',
        total: 'Toplam Elleçlenen',
        remaining: 'Kalan Miktar',
        remarks: 'Yük Açıklaması',
        note: 'Toplam = önceki günlüğün toplamı + son rapordan beri elleçlenen (öneri, değiştirilebilir). Kalan = planlanan − toplam.',
      },
      hours: {
        title: 'Makine Çalışma Saatleri',
        equipment: 'Ekipman',
        sinceLast: 'Son Rapordan (s)',
        today: 'Bugün (s)',
        total: 'Toplam (s)',
        sinceLastH: 'Son rapordan beri',
        todayH: 'Bugün',
        totalH: 'Toplam çalışma saati',
        remarks: 'Açıklama',
        remove: 'Satırı kaldır',
        none: 'Ekipman satırı yok.',
        add: 'Ekipman Ekle',
        note: 'Toplam = önceki toplam + son rapordan beri (öneri). Saatler bu raporda kalır; PMS sayaçları Öğle Raporundan ya da PMS’ten güncellenir.',
      },
    },
    // All Reports (ADR 0082; ortağın sefer-6)
    allReports: allReportsTr,
    record: voyageRecordTr,
    links: voyageLinksTr,
    context: voyageContextTr,
    charterParties: charterPartiesTr,
    cpAnalysis: cpAnalysisTr,
    // Seferin CP'si ve performans referansı (ADR 0084 Ek 2)
    cpReference: voyageReferenceTr,
    // Fuel & Consumption Analysis ve panonun sefer kartları (V6; ADR 0090)
    fuelAnalysis: fuelAnalysisTr,
    cards: voyageCardsTr,
    kinds: {
      departure: 'Kalkış Raporu',
      cosp: 'COSP Raporu',
      noon: 'Öğle Raporu',
      eosp: 'EOSP Raporu',
      arrival: 'Varış Raporu',
      port_daily: 'Limanda Günlük',
      anchorage_start: 'Demir Atıldı',
      anchorage_daily: 'Demirde Günlük',
      anchorage_end: 'Demir Alındı',
      waiting_start: 'Bekleme Başladı',
      waiting_end: 'Bekleme Bitti',
      drift_start: 'Sürüklenme Başladı',
      drift_daily: 'Sürüklenmede Günlük',
      drift_end: 'Sürüklenme Bitti',
      strait_entry: 'Boğaz Girişi',
      strait_exit: 'Boğaz Çıkışı',
      canal_entry: 'Kanal Girişi',
      canal_exit: 'Kanal Çıkışı',
      cargo_start: 'Yük Operasyonu Başladı',
      cargo_complete: 'Yük Operasyonu Bitti',
      on_hire: 'Kiraya Giriş',
      off_hire: 'Kiradan Çıkış',
    },
    voyageStatus: {
      planned: 'Planlandı',
      active: 'Sürüyor',
      completed: 'Tamamlandı',
      cancelled: 'İptal',
      void: 'İptal (Void)',
    },
    reportStatus: {
      draft: 'Taslak',
      submitted: 'Tamamlandı',
      reopened: 'Yeniden açıldı',
      void: 'İptal',
    },
    overview: {
      title: 'Sefer Özeti',
      description: 'Sefer özeti, raporlar ve çarter sözleşmesi performansı.',
      selectVoyage: 'Sefer',
      from: 'Nereden',
      to: 'Nereye',
      totalDistance: 'Toplam Mesafe',
      plannedSpeed: 'Planlanan Hız',
      plannedTime: 'Planlanan Süre',
      eta: 'Tahmini Varış Zamanı (ETA)',
      editVoyage: 'Seferi Düzenle',
      tree: 'Sefer Ağacı',
      created: 'Sefer Oluşturuldu',
      voyageNo: 'Sefer No: {{no}}',
      stages: { departure: 'Kalkış / Seyir', enRoute: 'Yolda', arrival: 'Varış' },
      completedNode: 'Sefer Tamamlandı',
      noReports: 'Henüz rapor yok.',
      summary: 'Sefer Özeti',
      actualDistance: 'Gerçekleşen Mesafe',
      avgSpeed: 'Ort. Hız',
      totalTime: 'Toplam Süre',
      delay: 'Gecikme',
      track: 'İz',
      trackNote: 'Konumlar sefer raporlarından.',
      noTrack: 'Henüz konum bildirilmedi.',
      speedPerformance: 'Hız Performansı',
      planned: 'Planlanan',
      difference: 'Fark',
      onCharter: 'Çarter sözleşmesine uygun',
      offCharter: 'Çarter hızının altında',
      cpCompliance: 'Çarter Sözleşmesi Uyumu',
      withinCp: 'CP içinde',
      allowedSpeed: 'İzin Verilen Hız',
      log: 'Seyir Günlüğü',
      date: 'Tarih',
      reportType: 'Rapor Türü',
      timeUtc: 'Saat (UTC)',
      speed: 'Hız (kn)',
      distance: 'Mesafe (NM)',
      status: 'Durum',
      keyFigures: 'Temel Değerler',
      departurePort: 'Kalkış Limanı',
      arrivalPort: 'Varış Limanı',
      distanceShort: 'Mesafe',
      actualArrival: 'Gerçekleşen Varış',
      cpStatus: 'Hız ve CP Durumu',
      parameter: 'Değer',
      actual: 'Gerçekleşen',
      ok: 'Uygun',
      check: 'Kontrol',
      withinCharter: 'Çarter Sözleşmesi İçinde',
      verdict: {
        within: 'Çarter Sözleşmesi İçinde',
        outside: 'Çarter Sözleşmesi Dışında',
        partial: 'Hız CP içinde',
        unknown: 'Değerlendirilmedi',
      },
      outsideCharter: 'Çarter Sözleşmesi Dışında',
      alerts: 'Uyarılar ve Bildirimler',
      draftPending: '{{kind}} gönderilmedi',
      noAlerts: 'Etkin uyarı yok.',
      quickActions: 'Hızlı İşlemler',
      createNoon: 'Öğle Raporu Oluştur',
      createEvent: 'Bacak / Olay Raporu',
      notes: 'Sefer Notları',
      noNotes: 'Henüz not eklenmedi.',
      documents: 'Belgeler',
      documentsLater: 'Sefer belgeleri ekler adımıyla gelir.',
      noVoyages: 'Bu gemi için henüz sefer yok.',
      shipPlanned: 'Seferleri gemi planlar; senkronla buraya gelir.',
      officePlan: 'Bu geminin ilk seferini Yeni Sefer ile planlayın.',
      etaUtc: 'Tahmini Varış Zamanı (ETA)',
      etd: 'Tahmini Kalkış Zamanı (ETD)',
      delayUnknown: 'Gecikme varış raporundan hesaplanır.',
      trackLabel: '{{from}} çıkışlı, {{to}} yönündeki seferin izi: {{count}} rapor konumu',
      cpStatusTable: 'Hız ve çarter sözleşmesi durumu',
      logTable: 'Seyir günlüğü tablosu',
      addReport: 'Rapor Ekle',
      showLatest: 'Son raporlar',
      viewAllCount: 'Tümü ({{count}})',
      noDocuments: 'Henüz belge eklenmedi.',
      documentsHint: 'Sefer belgeleri ekler adımıyla eklenir.',
      noReportsStage: 'Henüz rapor yok.',
      createDeparture: 'Departure Raporu Oluştur',
      firstReportHint:
        'Seferi Departure raporuyla başlatın. Sefer ortasında katılan gemi Leg / Event altında Noon ya da EOSP raporuyla başlayabilir.',
      reportsFromShip: 'Raporlar gemide girilir.',
      reportsFromShipHint:
        'Sefer raporları gemide girilir ve bir sonraki senkronla burada görünür.',
      noonReports: 'Öğle Raporları',
      viewAll: 'Tümü',
      speedWithin: 'Hız çarter sözleşmesi içinde',
      speedBelow: 'Hız çarter sözleşmesinin altında',
      throughout: 'Sefer boyunca',
      createArrival: 'Varış Raporu Oluştur',
      createCosp: 'COSP Raporu Oluştur',
      createEosp: 'EOSP Raporu Oluştur',
      error: 'Seferler yüklenemedi.',
      retry: 'Yeniden dene',
    },
    planner: {
      suggestNo: 'Önerilen numarayı kullan',
      voyageNoHint: 'Kendi sefer numaranızı yazın ya da öneriyi kullanmak için boş bırakın.',
      title: 'Yeni Sefer',
      editTitle: 'Seferi Düzenle',
      cardTitle: 'Yeni Sefer',
      fromDeparture:
        'Bu sefer {{port}} limanından {{no}} kalkışıyla başlar, son halat {{at}}. Bilinen değerler rapordan dolduruldu.',
      cardDescription: 'Planlanan çarter sözleşmesi bilgileriyle yeni sefer oluşturun.',
      status: 'Durum',
      information: 'Sefer Bilgileri',
      voyageNo: 'Sefer No',
      vessel: 'Gemi',
      fromPort: 'Kalkış Limanı',
      toPort: 'Varış Limanı',
      plannedDistance: 'Planlanan Mesafe',
      plannedEtd: 'Tahmini Kalkış Zamanı (ETD)',
      plannedEta: 'Tahmini Varış Zamanı (ETA)',
      utcOffset: 'UTC Farkı',
      utcOffsetOf: 'UTC Farkı ({{name}})',
      localTimeHint: 'Limanın yerel saati',
      remarks: 'Notlar',
      remarksPlaceholder: 'Not girin…',
      charterParty: 'Planlanan Çarter Sözleşmesi',
      cpSpeed: 'CP Hızı (knot)',
      cpRegisterNote:
        'Çarter şartları Çarter Sözleşmeleri listesinde bir kez tutulur (ofis). Sefer çarteri başlatmaz: çarter dönemi On Hire raporundan Off Hire raporuna kadardır.',
      cpRegisterOpen: 'Çarter Sözleşmelerini Aç',
      cpLegacy: 'Bu sefere önceki sürümde kaydedilmiş (salt okunur):',
      fuelConsumption: 'Yakıt Tüketimi',
      laden: 'Yüklü',
      ballast: 'Balast',
      fuelType: 'Yakıt Türü',
      mainEngine: 'Ana Makine',
      auxEngine: 'Yardımcı Makine',
      weatherLimit: 'CP Hava Sınırı',
      beaufortMax: 'Bofor (en çok)',
      waveHeight: 'Belirgin Dalga Yüksekliği',
      charterer: 'Kiracı',
      charterPartyNo: 'Çarter Sözleşmesi No',
      notes: 'Ek Notlar',
      notesPlaceholder: 'Ek not girin…',
      summary: 'Sefer Özeti',
      cpSpeedLaden: 'CP Hızı (Yüklü)',
      cpSpeedBallast: 'CP Hızı (Balast)',
      cpConsumptionLaden: 'CP Tüketimi (Yüklü)',
      cpConsumptionBallast: 'CP Tüketimi (Balast)',
      note: 'Not',
      noteText:
        'Sefer PLANLANDI durumuyla oluşturulur. Operasyon olayları (Kalkış, COSP, EOSP vb.) gemide raporlanır ve senkronla gelir.',
      cancel: 'Vazgeç',
      create: 'Seferi Oluştur',
      save: 'Seferi Kaydet',
      cancelVoyage: 'Seferi İptal Et',
      created: 'Sefer oluşturuldu.',
      saved: 'Sefer kaydedildi.',
      cancelled: 'Sefer iptal edildi.',
      shipOnly: 'Seferleri gemi planlar. Ofis senkronla görür.',
      request: 'Sefer Talebi Gönder',
      requested: 'Sefer talebi gemiye gönderildi.',
      requestNotice:
        'Ofis seferi talep olarak açar: gemi kendi kayıtlarından uygular, sefer senkronla gelir (ADR 0083).',
    },
    event: {
      title: 'Leg / Event',
      description:
        'Seferin operasyon olaylarını girin: kalkış, deniz seyri, demir, bekleme, boğaz, kanal, yük ve kiralama.',
      descriptionOffice: 'Geminin bildirdiği operasyon olayları (salt okunur).',
      events: 'Olaylar',
      log: 'Olay Günlüğü',
      add: 'Olay Ekle',
      event: 'Olay',
      position: 'Konum',
      noEvents: 'Henüz olay bildirilmedi.',
      empty: 'Günlükten bir olay seçin.',
      emptyShip: 'Günlükten bir olay seçin ya da yeni olay ekleyin.',
      eventTime: 'Olay Zamanı',
      pdf: '{{kind}} PDF',
      timePosition: 'Zaman ve Konum',
      details: 'Olay Bilgileri',
      draft: 'Draft',
      rob: 'Yakıt ROB',
      addFuel: 'Yakıt Ekle',
      removeRow: 'Yakıt satırını kaldır',
      remarks: 'Açıklama',
      summary: 'Önceki Rapordan Bu Yana',
      previous: 'Önceki Rapor',
      noPrevious: 'Önceki rapor yok',
      elapsed: 'Geçen Süre',
      distance: 'Mesafe',
      avgSpeed: 'Ort. Hız',
      saved: 'Taslak kaydedildi.',
      submitted: 'Olay gönderildi.',
      reopened: 'Olay yeniden açıldı.',
      removed: 'Taslak silindi.',
      submit: 'Olayı Gönder',
      submitStart: 'Gönder ve Seferi Başlat',
      remove: 'Taslağı Sil',
      removeTitle: 'Taslağı sil',
      removeBody: 'Taslak günlükten kaldırılır; geçmişi korunur.',
      cancel: 'Vazgeç',
      reopenedBecause: 'Yeniden açıldı: {{reason}}',
      status: {
        draft: 'Taslak',
        submitted: 'Tamamlandı',
        reopened: 'Yeniden açıldı',
        void: 'İptal',
        new: 'Yeni',
      },
      alerts: {
        none: 'Etkin uyarı yok.',
        OPEN_PASSAGE: '{{kind}} ile başlayan seyir sürüyor (EOSP yok)',
        DRAFT_PENDING: '{{kind}} gönderilmedi',
        MISSING_POSITION: '{{kind}}: mevki girilmedi',
        CRITICAL_DEFECTS: 'Gemide {{count}} kritik açık arıza',
        UNLINKED_DEPARTURES: '{{count}} rapor sefere bağlı değil',
      },
      categories: {
        port: 'Liman',
        passage: 'Seyir',
        anchorage: 'Demir / Bekleme / Sürüklenme',
        straitCanal: 'Boğaz / Kanal',
        commercial: 'Yük ve kiralama',
      },
      groups: {
        departure: 'Kalkış',
        passage: 'Bacak {{leg}} · COSP → EOSP',
        passageOpen: 'Bacak {{leg}} · COSP → denizde',
        arrival: 'Varış',
      },
      searchKinds: 'Olay türü ara',
      logTable: 'Olay günlüğü tablosu',
      distanceNm: 'Mesafe (NM)',
      noEventsShip: 'Seferi başlatmak için kalkış raporunu ekleyin.',
      eventTimeLocal: 'Olay Zamanı (yerel)',
      robMt: 'ROB (MT)',
      when: 'Tarih / Saat (UTC)',
      eventPosition: 'Olay / Mevki',
      legacyDeparture: 'Eski biçim: olay zamanı pilotun ayrılışı, Let Go son halattır (ADR 0058).',
      unlinkedTitle: 'Sefersiz',
      unlinkedLog: 'Sefersiz Raporlar',
      unlinkedNote:
        "Sefer açılmadan girilen raporlar, geminin sırasıyla. Gönderilmiş kalkıştan sefer başlatın ya da raporları Voyage Details'te bir sefere bağlayın.",
      noUnlinked: 'Sefersiz rapor yok.',
      noUnlinkedShip: 'Rapor ekleyin: sonra bir sefere bağlanabilir.',
      backToVoyage: 'Sefere dön',
      unlinkedLink: 'Sefersiz ({{count}})',
      amended: 'Düzeltildi',
      portCallApplied: 'Liman araması güncellendi.',
      error: 'Olaylar yüklenemedi.',
      retry: 'Yeniden dene',
      fields: {
        port: 'Liman',
        terminal: 'Terminal / Rıhtım',
        allFast: 'All Fast',
        pilotOnBoard: 'Pilot Gemide',
        letGo: 'Halatlar Bırakıldı / Kalkış (Let Go / Cast Off)',
        tugsUsed: 'Kullanılan Römorkör Sayısı',
        tugDetails: 'Römorkör Adları / Ayrıntılar',
        underway: 'Gemi Seyirde',
        course: 'Rota',
        rpm: 'Devir',
        speedKn: 'Hız',
        loadCondition: 'Yük Durumu',
        distanceSinceLast: 'Son Rapordan Bu Yana Mesafe',
        consumptionMt: 'Günlük Tüketim',
        reason: 'Neden',
        name: 'Ad',
        operation: 'Operasyon',
        charterPartyNo: 'Charter Party No',
        firstLine: 'İlk Halat',
        fwdM: 'Baş Draft',
        aftM: 'Kıç Draft',
        fuel: 'Yakıt',
        rob: 'ROB',
        pilotOff: 'Pilot Ayrıldı',
        berthSide: 'İskele / Sancak Tarafı',
        distanceToShoreM: 'Kıyıya Mesafe',
        distanceToPortNm: 'Limana Mesafe',
      },
      options: {
        reasons: {
          waiting_for_charter: 'Charter bekleniyor',
          waiting_for_berth: 'Rıhtım bekleniyor',
          waiting_for_orders: 'Emir bekleniyor',
          weather: 'Hava',
          traffic: 'Trafik',
          port_congestion: 'Liman yoğunluğu',
          other: 'Diğer',
        },
        loadConditions: { laden: 'Yüklü', ballast: 'Balast' },
        cargoOperations: { loading: 'Yükleme', discharging: 'Tahliye' },
        berthSides: { port: 'İskele tarafı', starboard: 'Sancak tarafı' },
      },
    },
    performance: {
      title: 'Voyage Performance',
      description:
        'Seferin tamamı, charter party penceresi ve boğaz/kanal segmentleri; gönderilmiş raporlardan hesaplanır.',
      voyage: 'Sefer',
      started: 'Sefer Başlangıcı',
      ended: 'Sefer Bitişi',
      overallDistance: 'Toplam Mesafe',
      overallTime: 'Toplam Süre',
      overallSpeed: 'Ortalama Hız',
      cpDistance: 'CP Mesafesi',
      cpTime: 'CP Süresi',
      cpSpeed: 'CP Ort. Hızı',
      segments: 'Performans Segmentleri',
      noSegments: 'Henüz performans verisi yok: gönderilmiş kalkış raporuyla başlar.',
      segment: 'Segment',
      period: 'Dönem (UTC)',
      hours: 'Saat',
      avgSpeed: 'Ort. Hız (kn)',
      cpRule: 'CP Uygulaması',
      overall: 'Seferin Tamamı',
      cpWindow: 'CP Penceresi (COSP → EOSP)',
      strait: 'Boğaz',
      canal: 'Kanal',
      ongoing: 'Sürüyor',
      allIncluded: 'Bütün operasyonlar dahil',
      excluded: '{{value}} sa hariç',
      notInCp: 'CP dışında',
      rules:
        'CP performansı yalnız COSP → EOSP aralığıdır; boğaz, kanal, demir, sürüklenme ve bekleme hariçtir. Seferin tamamı başlangıçtan bitişe hepsini kapsar.',
      speedByReport: 'Rapora Göre Hız',
      noSpeeds: 'Henüz mesafeli rapor yok.',
      avgSpeedLegend: 'Önceki rapordan bu yana ortalama hız',
      cpSpeedLegend: 'CP hızı {{value}} kn',
      legs: 'Rapor Bacakları',
      startedUtc: 'Sefer Başlangıcı (UTC)',
      endedUtc: 'Sefer Bitişi (UTC)',
      cpWindowN: 'CP Penceresi {{n}} (COSP → EOSP)',
      cpTotal: 'CP Toplamı',
      noExclusions: 'Hariç süre yok',
      segmentsTable: 'Performans bölümleri tablosu',
      legsTable: 'Rapor bacakları tablosu',
      vsCp: "CP'ye göre",
      legCp: { in: 'CP içinde', below: 'CP altında', outside: 'Pencere dışında' },
      belowCpLegend: 'CP hızının altında',
      outsideLegend: 'CP penceresi dışında',
      chartSummary:
        '{{count}} rapor bacağının ortalama hızı {{min}} ile {{max}} kn arasında; CP hızı {{cp}} kn; CP penceresinde {{below}} bacak CP hızının altında.',
      hoursSince: 'Önceki Rapordan Saat',
    },
    charterParty: {
      title: 'Charter Party Performance',
      description:
        'Charter party şartları ve COSP → EOSP performansının bunlarla karşılaştırması; Noon raporları CP hava sınırlarıyla.',
      terms: 'Charter Party Şartları',
      speedLadenBallast: 'CP Hızı (Yüklü / Balast)',
      consumptionLadenBallast: 'CP Tüketimi (Yüklü / Balast)',
      weatherLimit: 'CP Hava Sınırı',
      weatherLimitValue: 'Beaufort ≤ {{beaufort}}, dalga ≤ {{height}} m',
      fuel: 'Yakıt (Ana / Yardımcı)',
      window: 'CP Penceresi',
      cosp: 'COSP',
      eosp: 'EOSP',
      open: 'Açık (EOSP yok)',
      windowHours: 'Pencere',
      excludedHours: 'Hariç (boğaz, kanal, demir …)',
      performanceHours: 'Performans Süresi',
      distance: 'Performans Mesafesi',
      loadCondition: 'Yük Durumu',
      noWindow: 'COSP raporunu gönderin: CP penceresi onunla başlar.',
      status: 'CP Durumu',
      compliance: 'Hız uyumu (iyi hava)',
      dailyConsumption: 'Günlük Tüketim',
      goodWeatherDays: 'İyi Hava Günleri',
      goodBasis: '{{days}} gün · {{hours}} sa · {{distance}} NM',
      noGoodDays: 'Henüz iyi hava günü yok: CP değerlendirmesi için en az bir gün gerekir.',
      wholePeriod: 'Bütün CP Dönemi',
      rule: 'İyi hava günleriyle değerlendirilir: o günlerde hız = mesafe / süre, günlük tüketim = tüketim / süre × 24. Charter party içinde: hız CP değerinin altında, günlük tüketim üstünde değil (tolerans uygulanmaz). Bütün CP dönemi bilgi için gösterilir.',
      days: 'CP Penceresindeki Noon Raporları',
      goodDays: '{{total}} günün {{good}} günü CP hava sınırında',
      noDays: 'CP penceresinde henüz gönderilmiş Noon raporu yok.',
      vsCp: "CP'ye göre",
      below: 'Altında',
      beaufort: 'Beaufort',
      seaState: 'Deniz Durumu',
      swellHeight: 'Swell (m)',
      waveHeight: 'Hs (m)',
      goodWeather: 'İyi Hava',
      yes: 'Evet',
      no: 'Hayır',
      unknown: 'Bilinmiyor',
      excludedDay: 'Hariç',
      comparison: 'CP Karşılaştırması',
      goodWeatherTable: 'İyi hava günlerinin çarter sözleşmesiyle karşılaştırması',
      wholeTable: 'Bütün CP döneminin çarter sözleşmesiyle karşılaştırması',
      daysTable: 'CP penceresindeki öğle raporları',
      when: 'Tarih / Saat (UTC)',
      hours: 'Saat',
      excludedShort: 'Hariç',
      windowCount: 'CP Pencereleri',
      excludedHint: 'CP penceresindeki boğaz, kanal, demir, sürüklenme ve bekleme süresi.',
      noWindowTitle: 'Henüz CP penceresi yok',
      beaufortLimit: 'Bofor ≤ {{value}}',
      waveLimit: 'Hs ≤ {{value}} m',
      weatherNoteLabel: 'İyi hava günü nasıl belirlenir',
      pagination: 'Öğle raporu sayfaları',
      page: {
        first: 'İlk sayfa',
        previous: 'Önceki sayfa',
        next: 'Sonraki sayfa',
        last: 'Son sayfa',
        number: 'Sayfa {{page}}',
      },
      goodVerdict: {
        within: 'İyi hava: CP içinde',
        outside: 'İyi hava: CP dışında',
        partial: 'İyi hava: kısmi',
        unknown: 'İyi hava: değerlendirilmedi',
      },
      wholeVerdict: {
        within: 'Bütün dönem: CP içinde',
        outside: 'Bütün dönem: CP dışında',
        partial: 'Bütün dönem: kısmi',
        unknown: 'Bütün dönem: değerlendirilmedi',
      },
      verdictText: {
        within: 'İyi hava günlerinde çarter sözleşmesi sınırları içinde.',
        outside: 'İyi hava günlerinde çarter sözleşmesi sınırları dışında.',
        partial: 'Hız CP içinde · tüketim yok: tüketim henüz değerlendirilemiyor.',
        unknown: 'Henüz değerlendirilmedi: hızı ve tüketimi olan iyi hava günü yok.',
      },
      weatherNote:
        'İyi hava günü: Beaufort ve belirgin dalga yüksekliği (Hs) CP sınırları içinde. Hs = √(rüzgâr denizi² + swell²); rüzgâr denizi Douglas deniz durumunun üst sınırıdır (deniz durumu 9 her sınırı aşar). Beaufort, deniz durumu ya da swell girilmemiş gün sayılmaz; boğaz, kanal, demir, sürüklenme ya da bekleme içinde biten rapor hariçtir.',
    },
    // Düzenle ve sil (ADR 0077): taslaktan vazgeçme, gerekçeli iptal, seferin silinmesi
    withdraw: {
      removeDraft: 'Taslağı Sil',
      removeTitle: 'Taslağı sil',
      removeBody:
        'Taslak günlükten kalkar; değişiklik geçmişte kalır. Yalnız seferin son raporu silinebilir.',
      removed: 'Taslak silindi.',
      voidReport: 'Raporu İptal Et',
      voided: 'Rapor iptal edildi. Geçmişte "İptal" olarak kalır.',
      notLast:
        'Yalnız seferin son raporu silinebilir ya da iptal edilebilir. Önce sonraki raporları silin ya da iptal edin.',
      reopenMasterOnly:
        'Gönderilmiş rapor kilitlidir. Düzeltmek için kaptan gerekçeyle "Düzelt (yeniden aç)" der; düzeltilen rapor yeni revizyon olarak yeniden gönderilir.',
      voidedTitle: 'İptal (Void)',
      voidedBecause: 'Gerekçe: {{reason}} · {{at}} (UTC)',
      voyageTitle: 'Seferi sil',
      voyageDeleteHint: 'Bu seferin raporu yok. Silinince listelerden kalkar; geçmiş korunur.',
      voyageVoidHint:
        'Bu seferin {{count}} raporu var, silinemez. Gerekçeyle iptal edin: sefer ve raporları geçmişte "İptal" olarak kalır.',
      deleteVoyage: 'Seferi Sil',
      voidVoyage: 'Seferi İptal Et',
      deleteVoyageTitle: '{{no}} seferi silinsin mi?',
      deleteVoyageBody:
        'Sefer listelerden kalkar. Seferi başlatan kalkış seferi olmayan kalkışlara döner. Geçmiş korunur.',
      voyageVoidedTitle: 'Sefer iptal edildi',
    },
    voidDialog: {
      reason: 'Gerekçe',
      password: 'Parola',
      cancel: 'Vazgeç',
      report: {
        title: 'Raporu iptal et',
        lead: 'Rapor silinmez.',
        body: 'Geçmişte "İptal" olarak kalır; sefer hesaplarına ve rapor sırasına artık girmez. Geri alınamaz. Raporu düzeltmek istiyorsanız "Düzelt (yeniden aç)" kullanın.',
        confirm: 'Raporu İptal Et',
      },
      voyage: {
        title: 'Seferi iptal et',
        lead: 'Sefer silinmez.',
        body: 'Gerekçenizle "İptal" olarak görünür; raporları geçmişte kalır. Yeni rapor girilemez ve sefer artık düzeltilemez. Geri alınamaz.',
        confirm: 'Seferi İptal Et',
      },
    },
    errors: {
      REQUIRED: 'Zorunlu',
      OUT_OF_RANGE: 'Aralık dışında',
      NOT_INTEGER: 'Tam sayı olmalı',
      INVALID_NUMBER: 'Sayı girin',
      INVALID_DATETIME: 'Geçersiz tarih ve saat',
      INVALID_TZ_OFFSET: 'Geçersiz UTC farkı',
      INVALID_OPTION: 'Listeden seçin',
      TOO_LONG: 'Çok uzun',
      DUPLICATE: 'Yinelenen satır',
      TIME_ORDER: 'Zaman sırası bozuk',
      TIME_ORDER_AFTER:
        '{{ref}} ({{time}} LT) zamanından sonra olmalı. İki zamanı da kontrol edin.',
      TIME_ORDER_BEFORE:
        '{{ref}} ({{time}} LT) zamanından önce olmalı. İki zamanı da kontrol edin.',
      timeRefs: {
        reportedAt: 'rapor zamanı',
        castOff: 'Cast Off',
        pilotOnBoard: 'Pilot Bindi',
        firstLine: 'İlk Halat',
        allFast: 'All Fast',
        letGo: 'Let Go',
        tenderedAt: 'NOR Verildi',
        alongside: 'Römorkör Yanaştı',
      },
      SUMMARY_one: 'Kaydedilmedi: {{count}} alan düzeltilmeli: {{sections}}.',
      SUMMARY_other: 'Kaydedilmedi: {{count}} alan düzeltilmeli: {{sections}}.',
      SUMMARY_OTHER_FIELDS: 'diğer alanlar',
      INVALID_POSITION: "Biçim: 34° 45.6' N",
      FUTURE_DATE: 'Rapor zamanı gelecekte olamaz (gemi sunucusu saati).',
      REPORT_SUBMITTED: 'Rapor gönderilmiş ve kilitli.',
      ALREADY_SUBMITTED: 'Rapor zaten gönderilmiş.',
      CONTENT_CHANGED: 'Rapor sunucuda değişmiş. Yeniden yükleyip tekrar deneyin.',
      ROW_VERSION_CONFLICT:
        'Rapor başkası tarafından değiştirildi. Yeniden yükleyip tekrar deneyin.',
      INVALID_CREDENTIALS: 'Parola yanlış.',
      TOO_MANY_ATTEMPTS: 'Çok fazla deneme. Daha sonra tekrar deneyin.',
      REOPEN_REASON_REQUIRED: 'Gerekçe girin.',
      FORBIDDEN: 'Bu işlem için yetkiniz yok.',
      VOYAGE_UNKNOWN: 'Sefer bu gemiye ait değil.',
      VOYAGE_CANCELLED: 'Sefer iptal edilmiş.',
      SEQUENCE_NOT_AT_SEA: 'Öğle raporu açık bir deniz seyri ister (öncesinde COSP, EOSP yok).',
      SEQUENCE_BEFORE_DEPARTURE: 'Rapor seferin kalkışından önce.',
      SEQUENCE_DUPLICATE_DEPARTURE:
        'Kalkış seferin ilk raporu olmalı ya da bir yanaşma raporundan sonra gelmeli (her limanın kendi kalkışı).',
      SEQUENCE_ALREADY_OPEN: 'Bu dönem zaten açık; önce kapatın.',
      SEQUENCE_NOT_OPEN: 'Kapatılacak açık dönem yok (başlangıç raporu eksik).',
      SEQUENCE_NAME_MISMATCH: 'Çıkıştaki ad girişle aynı değil.',
      SEQUENCE_NOT_AT_ANCHOR: 'Günlük demir raporu için gemi demirde olmalı.',
      SEQUENCE_NOT_AT_BERTH:
        'Limanda günlük rapor için gemi rıhtımda olmalı (yanaşma raporundan sonra, kalkıştan önce).',
      SEQUENCE_NOT_DRIFTING:
        'Sürüklenmede günlük rapor için gemi sürükleniyor olmalı (drift başlangıcından sonra).',
      SEQUENCE_NEXT_OPERATION:
        'Bu rapor önceki raporda seçilen Sonraki İşleme uymuyor. Seçimin gösterdiği raporu açın ya da kaptandan önceki raporu yeniden açıp Sonraki İşlemi değiştirmesini isteyin.',
      NEXT_OPERATION_REQUIRED: 'Göndermeden önce Sonraki İşlemi seçin.',
      VESSEL_MISMATCH: 'Sefer başka bir gemiye ait.',
      DUPLICATE_VOYAGE_NO: 'Bu sefer numarası kullanılıyor.',
      VOYAGE_STARTED: 'Bu seferin raporu var, silinemez. Bunun yerine gerekçeyle iptal edin.',
      INVALID_VOYAGE: 'Bazı alanlar geçersiz.',
      UNKNOWN_PORT: 'Liman, liman listesinde yok.',
      INVALID_PORT_CODE: 'Liman kodu geçersiz.',
      INVALID_VOYAGE_REPORT: 'Bazı alanlar geçersiz.',
      VOYAGE_REQUIRED: 'Sefersiz yalnız kalkış raporu girilebilir.',
      VOYAGE_ACTION_MISMATCH: 'Sefer kararı raporun sefer bağıyla uyuşmuyor.',
      DEPARTURE_UNKNOWN: 'Kalkış raporu bu gemide değil.',
      DEPARTURE_LINKED: 'Bu kalkış zaten bir sefere bağlı.',
      REPORT_LINKED: 'Bu rapor zaten bir sefere bağlı. Önce bağı çözün.',
      REPORT_HAS_VOYAGE: 'Bu rapor bir sefer için girildi; yalnız sefersiz raporlar bağlanır.',
      VOYAGE_OVERLAP:
        'Seferler zamanda örtüşemez: bu rapor başka bir seferin aralığında. O sefere bağlayın ya da önce öteki raporların bağını çözün.',
      LINK_NOT_FOUND: 'Bu rapor sefere bağlı değil.',
      REQUEST_DECIDED: 'Bu talep zaten karara bağlandı.',
      INVALID_VOYAGE_REQUEST: 'Sefer talebi eksik.',
      DEPARTURE_NOT_SUBMITTED: 'Seferi başlatmadan önce kalkış raporunu gönderin.',
      LINK_UNKNOWN: 'Bağlı kayıt (liman araması, kontrol listesi ya da arıza) bu gemide değil.',
      NO_PORT_CALL: 'Rapor bir liman aramasına bağlı değil.',
      MISMATCH: 'Girilen satırlarla uyuşmuyor',
      CONFLICT: 'Pilot zamanlarını silin ya da N/A işaretini kaldırın',
      NOT_ALLOWED: 'Bu seçimde girilemez',
      EXCEEDS_TOTAL: 'Toplamdan büyük olamaz',
      INVALID_ID: 'Geçersiz bağ',
      NOT_FINAL: 'Önce raporu gönderin.',
      // Düzenle ve sil (ADR 0077)
      REPORT_NOT_LAST:
        'Yalnız seferin son raporu silinebilir ya da iptal edilebilir. Önce sonraki raporları silin ya da iptal edin.',
      REPORT_VOIDED: 'Rapor iptal edildi ve kilitli.',
      VOYAGE_VOIDED: 'Sefer iptal edildi; değiştirilemez.',
      VOID_REASON_REQUIRED: 'Gerekçe girin.',
      ALREADY_VOIDED: 'Zaten iptal edildi.',
      RECORD_NOT_SUBMITTED: 'Taslak iptal edilmez, silinir.',
      REAUTHENTICATION_REQUIRED: 'Parolanızı girin.',
      GENERIC: 'İşlem başarısız oldu. Tekrar deneyin.',
    },
  },
  materials: materialsTr,
  stock: stockTr,
  purchasing: purchasingTr,
  purchasingMarket: purchasingMarketTr,
  // Tedarikçi kartında profil ve banka (ADR 0114)
  supplierProfile: supplierProfileTr,
  supplierAccount: supplierAccountTr,
  // Tedarikçi carisi ve belge isteğinin e-postaları (ADR 0119 Ek 2026-10-24)
  supplierNotices: supplierNoticesTr,
  // Gemiye nihai liste ve mal kabulü (ADR 0115)
  purchasingShip: purchasingShipTr,
  // Limanlar ve mesafeler (M13b; ADR 0048)
  ports: portsTr,
  // Risk değerlendirmesi (M13d; ADR 0050)
  risk: riskTr,
  riskMaster: riskMasterTr,
  riskLibrary: riskLibraryTr,
  riskRegister: riskRegisterTr,
  riskDashboard: riskDashboardTr,
  riskVerification: riskVerificationTr,
  // Findings & Actions (K6; ADR 0094)
  riskFindings: riskFindingsTr,
  // Mürettebat bordrosu (M16; ADR 0061)
  payroll: payrollTr,
  cash: cashTr,
  // Kumanya (ADR 0099)
  provisions: provisionsTr,
  // Aylık iaşe raporu (ADR 0123)
  victualling: victuallingTr,
  // Yakıt yönetimi (ADR 0117)
  fuel: fuelTr,
  shipClock: shipClockTr,
  portCalls: { ...portCallsTr, pdf: portCallPdfTr },
  reports: reportsTr,
  pmsReports: pmsReportsTr,
  pmsAudit: pmsAuditTr,
  settingsScreen: settingsTr,
  // Felixmate Office Pack (ADR 0070)
  officePack: officePackTr,
  // Ek önizlemesi (ortak 2026-10-24 madde 4; ADR 0126)
  attachmentPreview: attachmentPreviewTr,
  // Sayfa bilgi penceresi ("i"; ADR 0053): pencere metinleri ve menü öğesi başına içerik
  pageHelp: pageHelpTr,
  help: helpTr,
  // Şirket kurulumu (ADR 0042 §22–§24; M8b4)
  setup: setupTr,
  // Doküman kütüphanesi (M8a3)
  documents: documentsTr,
  forms: formsTr,
  // İade ve ret bildirimi, diğer onay akışları (ADR 0116 Ek)
  masterSection: masterSectionTr,
  returned: returnedTr,
  // Panoda bana düşen işler (ADR 0156)
  tasks: tasksTr,
  pms: pmsTr,
  daily: dailyTr,
  // Compliance ▸ Vessel Certificates (M7d)
  vesselCertificates: vesselCertificatesTr,
  // Arıza DM-17 (ADR 0060)
  defects: defectsTr,
  hse: {
    ...hseTr,
    ...hseExtraTr,
    // Şirket uygunsuzluğu kodları HSE pencerelerinde de çözülür; HSE metni önceliklidir
    errors: { ...companyNcTr.errors, ...hseTr.errors },
  },
  // Ofisin şirket uygunsuzluğu ve ortak kayıt PDF'i (ADR 0062)
  companyNc: companyNcTr,
  recordPdf: recordPdfTr,
  pmsLibrary: pmsLibraryTr,
  classIntegration: classIntegrationTr,
  // Tatbikat yönetimi (ADR 0128)
  drills: drillsTr,
  drydock: drydockTr,
  // Dry dock raporları, denetim izi ve filo görünümü (ADR 0129 Ek Faz 5)
  drydockReport: drydockReportTr,
  drydockAudit: drydockAuditTr,
  drydockFleet: drydockFleetTr,
  drillPlan: drillPlanTr,
  drillRecord: drillRecordTr,
  drillFinding: drillFindingTr,
  drillReport: drillReportTr,
  // Crew List (IMO FAL Form 5; ADR 0130 §B)
  crewList: crewListTr,
  // Personel kartı (ADR 0131)
  crewProfile: crewProfileTr,
  // Crew Profile ▸ Office notes (ADR 0159)
  crewNotes: crewNotesTr,
  // Crew ▸ Login Accounts (ADR 0147)
  loginAccounts: loginAccountsTr,
  signOnOff: signOnOffTr,
  // Bağlı test ortamı hesapları (ADR 0092)
  testAccounts: testAccountsTr,
  stages: {
    M7: 'M7 — Planlı bakım',
    M8a: 'M8a — Doküman kütüphanesi ve ISM formları',
    M8b: 'M8b — Doldurulan ISM formları ve onaylar',
    M10d: 'M10d — Gemide dinlenme saatleri',
    M11: 'M11 — Sefer ve Öğle Raporu',
    M12a: 'M12a — Malzeme kataloğu ve stok',
    M12b: 'M12b — Talepler ve teklif',
    M12c: 'M12c — Sipariş ve mal kabul',
    phase2: 'Faz 2',
    phase3: 'Faz 3',
    V2: 'V2 — Sefer olayları, özeti ve zaman çizelgesi',
    V6: 'V6 — Yakıt ve tüketim analizi',
    withModules: 'her modülle birlikte',
    nextUpdate: 'gemi uygulamasının sonraki sürümü',
    office: 'ofis (web)',
  },
};
